var hn = Object.defineProperty, Cn = Object.defineProperties;
var vn = Object.getOwnPropertyDescriptors;
var ur = Object.getOwnPropertySymbols;
var zn = Object.prototype.hasOwnProperty, fn = Object.prototype.propertyIsEnumerable;
var sr = (o, e, t) => e in o ? hn(o, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[e] = t, g = (o, e) => {
  for (var t in e || (e = {}))
    zn.call(e, t) && sr(o, t, e[t]);
  if (ur)
    for (var t of ur(e))
      fn.call(e, t) && sr(o, t, e[t]);
  return o;
}, S = (o, e) => Cn(o, vn(e));
var Vo = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function kn(o) {
  return o && o.__esModule && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o;
}
function Pn() {
  this.__data__ = [], this.size = 0;
}
var yn = Pn;
function Ln(o, e) {
  return o === e || o !== o && e !== e;
}
var wo = Ln, Gn = wo;
function Hn(o, e) {
  for (var t = o.length; t--; )
    if (Gn(o[t][0], e))
      return t;
  return -1;
}
var Fo = Hn, Vn = Fo, _n = Array.prototype, An = _n.splice;
function Rn(o) {
  var e = this.__data__, t = Vn(e, o);
  if (t < 0)
    return !1;
  var c = e.length - 1;
  return t == c ? e.pop() : An.call(e, t, 1), --this.size, !0;
}
var $n = Rn, Mn = Fo;
function Dn(o) {
  var e = this.__data__, t = Mn(e, o);
  return t < 0 ? void 0 : e[t][1];
}
var wn = Dn, Fn = Fo;
function Nn(o) {
  return Fn(this.__data__, o) > -1;
}
var On = Nn, Wn = Fo;
function Xn(o, e) {
  var t = this.__data__, c = Wn(t, o);
  return c < 0 ? (++this.size, t.push([o, e])) : t[c][1] = e, this;
}
var En = Xn, jn = yn, Un = $n, Kn = wn, qn = On, Jn = En;
function po(o) {
  var e = -1, t = o == null ? 0 : o.length;
  for (this.clear(); ++e < t; ) {
    var c = o[e];
    this.set(c[0], c[1]);
  }
}
po.prototype.clear = jn;
po.prototype.delete = Un;
po.prototype.get = Kn;
po.prototype.has = qn;
po.prototype.set = Jn;
var No = po, Yn = No;
function Zn() {
  this.__data__ = new Yn(), this.size = 0;
}
var Qn = Zn;
function oe(o) {
  var e = this.__data__, t = e.delete(o);
  return this.size = e.size, t;
}
var re = oe;
function ne(o) {
  return this.__data__.get(o);
}
var ee = ne;
function ae(o) {
  return this.__data__.has(o);
}
var ie = ae, te = typeof Vo == "object" && Vo && Vo.Object === Object && Vo, Vr = te, ce = Vr, le = typeof self == "object" && self && self.Object === Object && self, de = ce || le || Function("return this")(), Io = de, ue = Io, se = ue.Symbol, _r = se, gr = _r, Ar = Object.prototype, ge = Ar.hasOwnProperty, pe = Ar.toString, zo = gr ? gr.toStringTag : void 0;
function Ie(o) {
  var e = ge.call(o, zo), t = o[zo];
  try {
    o[zo] = void 0;
    var c = !0;
  } catch (I) {
  }
  var d = pe.call(o);
  return c && (e ? o[zo] = t : delete o[zo]), d;
}
var be = Ie, Te = Object.prototype, Se = Te.toString;
function xe(o) {
  return Se.call(o);
}
var Be = xe, pr = _r, me = be, he = Be, Ce = "[object Null]", ve = "[object Undefined]", Ir = pr ? pr.toStringTag : void 0;
function ze(o) {
  return o == null ? o === void 0 ? ve : Ce : Ir && Ir in Object(o) ? me(o) : he(o);
}
var Oo = ze;
function fe(o) {
  var e = typeof o;
  return o != null && (e == "object" || e == "function");
}
var eo = fe, ke = Oo, Pe = eo, ye = "[object AsyncFunction]", Le = "[object Function]", Ge = "[object GeneratorFunction]", He = "[object Proxy]";
function Ve(o) {
  if (!Pe(o))
    return !1;
  var e = ke(o);
  return e == Le || e == Ge || e == ye || e == He;
}
var nr = Ve, _e = Io, Ae = _e["__core-js_shared__"], Re = Ae, rr = Re, br = function() {
  var o = /[^.]+$/.exec(rr && rr.keys && rr.keys.IE_PROTO || "");
  return o ? "Symbol(src)_1." + o : "";
}();
function $e(o) {
  return !!br && br in o;
}
var Me = $e, De = Function.prototype, we = De.toString;
function Fe(o) {
  if (o != null) {
    try {
      return we.call(o);
    } catch (e) {
    }
    try {
      return o + "";
    } catch (e) {
    }
  }
  return "";
}
var Ne = Fe, Oe = nr, We = Me, Xe = eo, Ee = Ne, je = /[\\^$.*+?()[\]{}|]/g, Ue = /^\[object .+?Constructor\]$/, Ke = Function.prototype, qe = Object.prototype, Je = Ke.toString, Ye = qe.hasOwnProperty, Ze = RegExp(
  "^" + Je.call(Ye).replace(je, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Qe(o) {
  if (!Xe(o) || We(o))
    return !1;
  var e = Oe(o) ? Ze : Ue;
  return e.test(Ee(o));
}
var oa = Qe;
function ra(o, e) {
  return o == null ? void 0 : o[e];
}
var na = ra, ea = oa, aa = na;
function ia(o, e) {
  var t = aa(o, e);
  return ea(t) ? t : void 0;
}
var er = ia, ta = er, ca = Io, la = ta(ca, "Map"), Rr = la, da = er, ua = da(Object, "create"), Wo = ua, Tr = Wo;
function sa() {
  this.__data__ = Tr ? Tr(null) : {}, this.size = 0;
}
var ga = sa;
function pa(o) {
  var e = this.has(o) && delete this.__data__[o];
  return this.size -= e ? 1 : 0, e;
}
var Ia = pa, ba = Wo, Ta = "__lodash_hash_undefined__", Sa = Object.prototype, xa = Sa.hasOwnProperty;
function Ba(o) {
  var e = this.__data__;
  if (ba) {
    var t = e[o];
    return t === Ta ? void 0 : t;
  }
  return xa.call(e, o) ? e[o] : void 0;
}
var ma = Ba, ha = Wo, Ca = Object.prototype, va = Ca.hasOwnProperty;
function za(o) {
  var e = this.__data__;
  return ha ? e[o] !== void 0 : va.call(e, o);
}
var fa = za, ka = Wo, Pa = "__lodash_hash_undefined__";
function ya(o, e) {
  var t = this.__data__;
  return this.size += this.has(o) ? 0 : 1, t[o] = ka && e === void 0 ? Pa : e, this;
}
var La = ya, Ga = ga, Ha = Ia, Va = ma, _a = fa, Aa = La;
function bo(o) {
  var e = -1, t = o == null ? 0 : o.length;
  for (this.clear(); ++e < t; ) {
    var c = o[e];
    this.set(c[0], c[1]);
  }
}
bo.prototype.clear = Ga;
bo.prototype.delete = Ha;
bo.prototype.get = Va;
bo.prototype.has = _a;
bo.prototype.set = Aa;
var Ra = bo, Sr = Ra, $a = No, Ma = Rr;
function Da() {
  this.size = 0, this.__data__ = {
    hash: new Sr(),
    map: new (Ma || $a)(),
    string: new Sr()
  };
}
var wa = Da;
function Fa(o) {
  var e = typeof o;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? o !== "__proto__" : o === null;
}
var Na = Fa, Oa = Na;
function Wa(o, e) {
  var t = o.__data__;
  return Oa(e) ? t[typeof e == "string" ? "string" : "hash"] : t.map;
}
var Xo = Wa, Xa = Xo;
function Ea(o) {
  var e = Xa(this, o).delete(o);
  return this.size -= e ? 1 : 0, e;
}
var ja = Ea, Ua = Xo;
function Ka(o) {
  return Ua(this, o).get(o);
}
var qa = Ka, Ja = Xo;
function Ya(o) {
  return Ja(this, o).has(o);
}
var Za = Ya, Qa = Xo;
function oi(o, e) {
  var t = Qa(this, o), c = t.size;
  return t.set(o, e), this.size += t.size == c ? 0 : 1, this;
}
var ri = oi, ni = wa, ei = ja, ai = qa, ii = Za, ti = ri;
function To(o) {
  var e = -1, t = o == null ? 0 : o.length;
  for (this.clear(); ++e < t; ) {
    var c = o[e];
    this.set(c[0], c[1]);
  }
}
To.prototype.clear = ni;
To.prototype.delete = ei;
To.prototype.get = ai;
To.prototype.has = ii;
To.prototype.set = ti;
var ci = To, li = No, di = Rr, ui = ci, si = 200;
function gi(o, e) {
  var t = this.__data__;
  if (t instanceof li) {
    var c = t.__data__;
    if (!di || c.length < si - 1)
      return c.push([o, e]), this.size = ++t.size, this;
    t = this.__data__ = new ui(c);
  }
  return t.set(o, e), this.size = t.size, this;
}
var pi = gi, Ii = No, bi = Qn, Ti = re, Si = ee, xi = ie, Bi = pi;
function So(o) {
  var e = this.__data__ = new Ii(o);
  this.size = e.size;
}
So.prototype.clear = bi;
So.prototype.delete = Ti;
So.prototype.get = Si;
So.prototype.has = xi;
So.prototype.set = Bi;
var mi = So, hi = er, Ci = function() {
  try {
    var o = hi(Object, "defineProperty");
    return o({}, "", {}), o;
  } catch (e) {
  }
}(), $r = Ci, xr = $r;
function vi(o, e, t) {
  e == "__proto__" && xr ? xr(o, e, {
    configurable: !0,
    enumerable: !0,
    value: t,
    writable: !0
  }) : o[e] = t;
}
var ar = vi, zi = ar, fi = wo;
function ki(o, e, t) {
  (t !== void 0 && !fi(o[e], t) || t === void 0 && !(e in o)) && zi(o, e, t);
}
var Mr = ki;
function Pi(o) {
  return function(e, t, c) {
    for (var d = -1, I = Object(e), b = c(e), s = b.length; s--; ) {
      var T = b[o ? s : ++d];
      if (t(I[T], T, I) === !1)
        break;
    }
    return e;
  };
}
var yi = Pi, Li = yi, Gi = Li(), Hi = Gi, Ao = { exports: {} };
Ao.exports;
(function(o, e) {
  var t = Io, c = e && !e.nodeType && e, d = c && !0 && o && !o.nodeType && o, I = d && d.exports === c, b = I ? t.Buffer : void 0, s = b ? b.allocUnsafe : void 0;
  function T(v, _) {
    if (_)
      return v.slice();
    var q = v.length, to = s ? s(q) : new v.constructor(q);
    return v.copy(to), to;
  }
  o.exports = T;
})(Ao, Ao.exports);
var Vi = Ao.exports, _i = Io, Ai = _i.Uint8Array, Ri = Ai, Br = Ri;
function $i(o) {
  var e = new o.constructor(o.byteLength);
  return new Br(e).set(new Br(o)), e;
}
var Mi = $i, Di = Mi;
function wi(o, e) {
  var t = e ? Di(o.buffer) : o.buffer;
  return new o.constructor(t, o.byteOffset, o.length);
}
var Fi = wi;
function Ni(o, e) {
  var t = -1, c = o.length;
  for (e || (e = Array(c)); ++t < c; )
    e[t] = o[t];
  return e;
}
var Oi = Ni, Wi = eo, mr = Object.create, Xi = function() {
  function o() {
  }
  return function(e) {
    if (!Wi(e))
      return {};
    if (mr)
      return mr(e);
    o.prototype = e;
    var t = new o();
    return o.prototype = void 0, t;
  };
}(), Ei = Xi;
function ji(o, e) {
  return function(t) {
    return o(e(t));
  };
}
var Ui = ji, Ki = Ui, qi = Ki(Object.getPrototypeOf, Object), Dr = qi, Ji = Object.prototype;
function Yi(o) {
  var e = o && o.constructor, t = typeof e == "function" && e.prototype || Ji;
  return o === t;
}
var wr = Yi, Zi = Ei, Qi = Dr, ot = wr;
function rt(o) {
  return typeof o.constructor == "function" && !ot(o) ? Zi(Qi(o)) : {};
}
var nt = rt;
function et(o) {
  return o != null && typeof o == "object";
}
var Po = et, at = Oo, it = Po, tt = "[object Arguments]";
function ct(o) {
  return it(o) && at(o) == tt;
}
var lt = ct, hr = lt, dt = Po, Fr = Object.prototype, ut = Fr.hasOwnProperty, st = Fr.propertyIsEnumerable, gt = hr(function() {
  return arguments;
}()) ? hr : function(o) {
  return dt(o) && ut.call(o, "callee") && !st.call(o, "callee");
}, Nr = gt, pt = Array.isArray, Or = pt, It = 9007199254740991;
function bt(o) {
  return typeof o == "number" && o > -1 && o % 1 == 0 && o <= It;
}
var Wr = bt, Tt = nr, St = Wr;
function xt(o) {
  return o != null && St(o.length) && !Tt(o);
}
var ir = xt, Bt = ir, mt = Po;
function ht(o) {
  return mt(o) && Bt(o);
}
var Ct = ht, Ro = { exports: {} };
function vt() {
  return !1;
}
var zt = vt;
Ro.exports;
(function(o, e) {
  var t = Io, c = zt, d = e && !e.nodeType && e, I = d && !0 && o && !o.nodeType && o, b = I && I.exports === d, s = b ? t.Buffer : void 0, T = s ? s.isBuffer : void 0, v = T || c;
  o.exports = v;
})(Ro, Ro.exports);
var Xr = Ro.exports, ft = Oo, kt = Dr, Pt = Po, yt = "[object Object]", Lt = Function.prototype, Gt = Object.prototype, Er = Lt.toString, Ht = Gt.hasOwnProperty, Vt = Er.call(Object);
function _t(o) {
  if (!Pt(o) || ft(o) != yt)
    return !1;
  var e = kt(o);
  if (e === null)
    return !0;
  var t = Ht.call(e, "constructor") && e.constructor;
  return typeof t == "function" && t instanceof t && Er.call(t) == Vt;
}
var At = _t, Rt = Oo, $t = Wr, Mt = Po, Dt = "[object Arguments]", wt = "[object Array]", Ft = "[object Boolean]", Nt = "[object Date]", Ot = "[object Error]", Wt = "[object Function]", Xt = "[object Map]", Et = "[object Number]", jt = "[object Object]", Ut = "[object RegExp]", Kt = "[object Set]", qt = "[object String]", Jt = "[object WeakMap]", Yt = "[object ArrayBuffer]", Zt = "[object DataView]", Qt = "[object Float32Array]", oc = "[object Float64Array]", rc = "[object Int8Array]", nc = "[object Int16Array]", ec = "[object Int32Array]", ac = "[object Uint8Array]", ic = "[object Uint8ClampedArray]", tc = "[object Uint16Array]", cc = "[object Uint32Array]", B = {};
B[Qt] = B[oc] = B[rc] = B[nc] = B[ec] = B[ac] = B[ic] = B[tc] = B[cc] = !0;
B[Dt] = B[wt] = B[Yt] = B[Ft] = B[Zt] = B[Nt] = B[Ot] = B[Wt] = B[Xt] = B[Et] = B[jt] = B[Ut] = B[Kt] = B[qt] = B[Jt] = !1;
function lc(o) {
  return Mt(o) && $t(o.length) && !!B[Rt(o)];
}
var dc = lc;
function uc(o) {
  return function(e) {
    return o(e);
  };
}
var sc = uc, $o = { exports: {} };
$o.exports;
(function(o, e) {
  var t = Vr, c = e && !e.nodeType && e, d = c && !0 && o && !o.nodeType && o, I = d && d.exports === c, b = I && t.process, s = function() {
    try {
      var T = d && d.require && d.require("util").types;
      return T || b && b.binding && b.binding("util");
    } catch (v) {
    }
  }();
  o.exports = s;
})($o, $o.exports);
var gc = $o.exports, pc = dc, Ic = sc, Cr = gc, vr = Cr && Cr.isTypedArray, bc = vr ? Ic(vr) : pc, jr = bc;
function Tc(o, e) {
  if (!(e === "constructor" && typeof o[e] == "function") && e != "__proto__")
    return o[e];
}
var Ur = Tc, Sc = ar, xc = wo, Bc = Object.prototype, mc = Bc.hasOwnProperty;
function hc(o, e, t) {
  var c = o[e];
  (!(mc.call(o, e) && xc(c, t)) || t === void 0 && !(e in o)) && Sc(o, e, t);
}
var Cc = hc, vc = Cc, zc = ar;
function fc(o, e, t, c) {
  var d = !t;
  t || (t = {});
  for (var I = -1, b = e.length; ++I < b; ) {
    var s = e[I], T = c ? c(t[s], o[s], s, t, o) : void 0;
    T === void 0 && (T = o[s]), d ? zc(t, s, T) : vc(t, s, T);
  }
  return t;
}
var kc = fc;
function Pc(o, e) {
  for (var t = -1, c = Array(o); ++t < o; )
    c[t] = e(t);
  return c;
}
var yc = Pc, Lc = 9007199254740991, Gc = /^(?:0|[1-9]\d*)$/;
function Hc(o, e) {
  var t = typeof o;
  return e = e == null ? Lc : e, !!e && (t == "number" || t != "symbol" && Gc.test(o)) && o > -1 && o % 1 == 0 && o < e;
}
var Kr = Hc, Vc = yc, _c = Nr, Ac = Or, Rc = Xr, $c = Kr, Mc = jr, Dc = Object.prototype, wc = Dc.hasOwnProperty;
function Fc(o, e) {
  var t = Ac(o), c = !t && _c(o), d = !t && !c && Rc(o), I = !t && !c && !d && Mc(o), b = t || c || d || I, s = b ? Vc(o.length, String) : [], T = s.length;
  for (var v in o)
    (e || wc.call(o, v)) && !(b && // Safari 9 has enumerable `arguments.length` in strict mode.
    (v == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    d && (v == "offset" || v == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    I && (v == "buffer" || v == "byteLength" || v == "byteOffset") || // Skip index properties.
    $c(v, T))) && s.push(v);
  return s;
}
var Nc = Fc;
function Oc(o) {
  var e = [];
  if (o != null)
    for (var t in Object(o))
      e.push(t);
  return e;
}
var Wc = Oc, Xc = eo, Ec = wr, jc = Wc, Uc = Object.prototype, Kc = Uc.hasOwnProperty;
function qc(o) {
  if (!Xc(o))
    return jc(o);
  var e = Ec(o), t = [];
  for (var c in o)
    c == "constructor" && (e || !Kc.call(o, c)) || t.push(c);
  return t;
}
var Jc = qc, Yc = Nc, Zc = Jc, Qc = ir;
function ol(o) {
  return Qc(o) ? Yc(o, !0) : Zc(o);
}
var qr = ol, rl = kc, nl = qr;
function el(o) {
  return rl(o, nl(o));
}
var al = el, zr = Mr, il = Vi, tl = Fi, cl = Oi, ll = nt, fr = Nr, kr = Or, dl = Ct, ul = Xr, sl = nr, gl = eo, pl = At, Il = jr, Pr = Ur, bl = al;
function Tl(o, e, t, c, d, I, b) {
  var s = Pr(o, t), T = Pr(e, t), v = b.get(T);
  if (v) {
    zr(o, t, v);
    return;
  }
  var _ = I ? I(s, T, t + "", o, e, b) : void 0, q = _ === void 0;
  if (q) {
    var to = kr(T), or = !to && ul(T), dr = !to && !or && Il(T);
    _ = T, to || or || dr ? kr(s) ? _ = s : dl(s) ? _ = cl(s) : or ? (q = !1, _ = il(T, !0)) : dr ? (q = !1, _ = tl(T, !0)) : _ = [] : pl(T) || fr(T) ? (_ = s, fr(s) ? _ = bl(s) : (!gl(s) || sl(s)) && (_ = ll(T))) : q = !1;
  }
  q && (b.set(T, _), d(_, T, c, I, b), b.delete(T)), zr(o, t, _);
}
var Sl = Tl, xl = mi, Bl = Mr, ml = Hi, hl = Sl, Cl = eo, vl = qr, zl = Ur;
function Jr(o, e, t, c, d) {
  o !== e && ml(e, function(I, b) {
    if (d || (d = new xl()), Cl(I))
      hl(o, e, b, t, Jr, c, d);
    else {
      var s = c ? c(zl(o, b), I, b + "", o, e, d) : void 0;
      s === void 0 && (s = I), Bl(o, b, s);
    }
  }, vl);
}
var fl = Jr;
function kl(o) {
  return o;
}
var Yr = kl;
function Pl(o, e, t) {
  switch (t.length) {
    case 0:
      return o.call(e);
    case 1:
      return o.call(e, t[0]);
    case 2:
      return o.call(e, t[0], t[1]);
    case 3:
      return o.call(e, t[0], t[1], t[2]);
  }
  return o.apply(e, t);
}
var yl = Pl, Ll = yl, yr = Math.max;
function Gl(o, e, t) {
  return e = yr(e === void 0 ? o.length - 1 : e, 0), function() {
    for (var c = arguments, d = -1, I = yr(c.length - e, 0), b = Array(I); ++d < I; )
      b[d] = c[e + d];
    d = -1;
    for (var s = Array(e + 1); ++d < e; )
      s[d] = c[d];
    return s[e] = t(b), Ll(o, this, s);
  };
}
var Hl = Gl;
function Vl(o) {
  return function() {
    return o;
  };
}
var _l = Vl, Al = _l, Lr = $r, Rl = Yr, $l = Lr ? function(o, e) {
  return Lr(o, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Al(e),
    writable: !0
  });
} : Rl, Ml = $l, Dl = 800, wl = 16, Fl = Date.now;
function Nl(o) {
  var e = 0, t = 0;
  return function() {
    var c = Fl(), d = wl - (c - t);
    if (t = c, d > 0) {
      if (++e >= Dl)
        return arguments[0];
    } else
      e = 0;
    return o.apply(void 0, arguments);
  };
}
var Ol = Nl, Wl = Ml, Xl = Ol, El = Xl(Wl), jl = El, Ul = Yr, Kl = Hl, ql = jl;
function Jl(o, e) {
  return ql(Kl(o, e, Ul), o + "");
}
var Yl = Jl, Zl = wo, Ql = ir, od = Kr, rd = eo;
function nd(o, e, t) {
  if (!rd(t))
    return !1;
  var c = typeof e;
  return (c == "number" ? Ql(t) && od(e, t.length) : c == "string" && e in t) ? Zl(t[e], o) : !1;
}
var ed = nd, ad = Yl, id = ed;
function td(o) {
  return ad(function(e, t) {
    var c = -1, d = t.length, I = d > 1 ? t[d - 1] : void 0, b = d > 2 ? t[2] : void 0;
    for (I = o.length > 3 && typeof I == "function" ? (d--, I) : void 0, b && id(t[0], t[1], b) && (I = d < 3 ? void 0 : I, d = 1), e = Object(e); ++c < d; ) {
      var s = t[c];
      s && o(e, s, c, I);
    }
    return e;
  });
}
var cd = td, ld = fl, dd = cd, ud = dd(function(o, e, t) {
  ld(o, e, t);
}), sd = ud;
const gd = /* @__PURE__ */ kn(sd), pd = [
  "space",
  "breakpoints",
  "borderRadius",
  "main"
];
function Id(o) {
  return g(g(g(g(g({}, bd(o.space)), Td(o.breakpointSizes)), Sd(o.borderRadius)), xd(o.main.colours)), Bd(o.main.shadows));
}
function bd(o) {
  return o.reduce((e, t, c) => (e[`space_${c}`] = o[c], e), {});
}
function Td(o) {
  return {
    brk_xs: o.xs,
    brk_sm: o.sm,
    brk_md: o.md,
    brk_lg: o.lg,
    brk_xl: o.xl
  };
}
function Sd(o) {
  return Object.keys(o).reduce((e, t) => (e[`rad_${t}`] = o[t], e), {});
}
function xd(o) {
  return {
    cl_white: o.white,
    cl_black: o.black,
    cl_successGreen: o.successGreen,
    cl_errorRed: o.errorRed,
    cl_divider: o.divider,
    /* Primary colors */
    cl_pri_l3: o.primary.l3,
    cl_pri_l2: o.primary.l2,
    cl_pri_l1: o.primary.l1,
    cl_pri_base: o.primary.base,
    cl_pri_d1: o.primary.d1,
    cl_pri_d2: o.primary.d2,
    cl_pri_d3: o.primary.d3,
    cl_pri_d4: o.primary.d4,
    /* Secondary colors */
    cl_sec_l2: o.secondary.l2,
    cl_sec_l1: o.secondary.l1,
    cl_sec_base: o.secondary.base,
    cl_sec_d1: o.secondary.d1,
    cl_sec_d2: o.secondary.d2,
    cl_sec_d3: o.secondary.d3,
    /* Tertiary colors */
    cl_ter_l6: o.tertiary.l6,
    cl_ter_l5: o.tertiary.l5,
    cl_ter_l4: o.tertiary.l4,
    cl_ter_l3: o.tertiary.l3,
    cl_ter_l2: o.tertiary.l2,
    cl_ter_l1: o.tertiary.l1,
    cl_ter_base: o.tertiary.base,
    cl_ter_d1: o.tertiary.d1
  };
}
function Bd(o) {
  return {
    sd_size_1: o.size1,
    sd_size_2: o.size2
  };
}
const md = (o, e) => {
  if (!e)
    return o;
  const t = g({}, o);
  return Object.keys(e).forEach((c) => {
    c in t && (t[c] = g(g({}, t[c]), e[c]), delete e[c]), pd.includes(c) && delete e[c];
  }), g(g({}, t), e);
};
function hd(o, e) {
  return o + Math.round(e * 255).toString(16);
}
const Eo = 1, xo = 2, Zr = "[object Object]", go = 8, Qr = 16, on = 32, rn = 40, tr = "#fceaed", Cd = "#ffd2d9", yo = "#ff5d76", vd = "#ed1a3d", J = "#e71336", ao = "#ca112f", Mo = "#bc1430", zd = "#6d0819", io = "#0caa8f", Lo = "#ffb824", Bo = "#bc1430", nn = "#ff5d76", w = "#f7f7f7", P = "#e1e1e1", A = "#a8a8a8", G = "#757575", ko = "#565656", jo = "#3b3b3b", y = "#222222", p = "#ffffff", fd = "#000000", Uo = "#EBF2FF", mo = "#CCDFFF", Go = "#6699FF", F = "#0062F5", en = "#0044CC", an = "#d0d0d0", tn = "rgba(168,168,168,0.5)", Ho = "#EFEDFD", Ko = "#DEDAFA", cn = "#9A8EF2", H = "#5C50BB", cr = "#5457A0", ln = "#151560", lr = "Museo", $ = "Lato", uo = 400, kd = 500, no = 600, W = 700, Gr = 900, u = 12, k = 14, l = 16, h = 18, L = 20, V = 24, z = 32, K = 40, Do = 48, so = 1.2, dn = 1.25, D = 1.5, Pd = 0.3, qo = 0.5, Jo = 0.8, un = "0px 3px 8px 0px rgba(0, 0, 0, 0.12)", sn = { shadowColor: "rgba(0, 0, 0, 0.12)", shadowOffset: { width: 0, height: "3" }, shadowOpacity: 0.12, shadowRadius: "3", elevation: "0" }, gn = "0px 6px 16px 0px rgba(0, 0, 0, 0.10)", pn = "0px -6px 16px 0px rgba(0, 0, 0, 0.10)", m = 8, ho = 16, Y = 24, Z = 32, Q = 40, j = 48, Co = 56, In = 64, vo = 72, bn = 80, Tn = 88, C = 4, f = 8, M = 16, oo = 24, Yo = 32, Zo = 40, Sn = 64, co = 0.01, lo = 0.02, U = 0.03;
function R(o, e) {
  return `${o}${e}`;
}
const X = {
  marginTop: 0,
  marginBottom: 0,
  fontWeight: "unset",
  letterSpacing: 0,
  textRendering: "optimizeLegibility",
  "-webkit-font-smoothing": "antialiased"
}, E = {
  primary: `${$}, Adobe Heiti Std, Segoe UI, Trebuchet MS, sans-serif`,
  secondary: `${lr}, Georgia, Times New Roman, Times, serif`
}, yd = {
  bannerTitle: S(g({}, X), {
    fontSize: [
      K,
      K,
      K,
      Do,
      Do
    ],
    fontFamily: E.secondary,
    lineHeight: so,
    fontWeight: kd
  }),
  pageTitle: S(g({}, X), {
    fontSize: [
      z,
      z,
      z,
      K,
      K
    ],
    fontFamily: E.primary,
    lineHeight: so,
    fontWeight: Gr
  }),
  sectionTitle: S(g({}, X), {
    fontSize: [
      V,
      V,
      V,
      z,
      z
    ],
    fontFamily: E.primary,
    lineHeight: so,
    fontWeight: Gr
  }),
  header: S(g({}, X), {
    fontFamily: E.primary,
    fontWeight: W,
    fontSize: [
      L,
      L,
      L,
      V,
      V
    ],
    lineHeight: dn,
    letterSpacing: [
      R(co, "em"),
      R(co, "em"),
      R(co, "em"),
      0,
      0
    ]
  }),
  boldBody: S(g({}, X), {
    fontFamily: E.primary,
    fontWeight: W,
    fontSize: [
      l,
      l,
      l,
      h,
      h
    ],
    lineHeight: D,
    letterSpacing: R(lo, "em")
  }),
  body: S(g({}, X), {
    fontFamily: E.primary,
    fontWeight: uo,
    fontSize: [
      l,
      l,
      l,
      h,
      h
    ],
    lineHeight: D,
    letterSpacing: R(co, "em")
  }),
  smallBody: S(g({}, X), {
    fontFamily: E.primary,
    fontWeight: uo,
    fontWeightSemiBold: no,
    fontSize: [
      u,
      u,
      u,
      k,
      k
    ],
    lineHeight: D,
    letterSpacing: [
      R(U, "em"),
      R(U, "em"),
      R(U, "em"),
      R(lo, "em"),
      R(lo, "em")
    ],
    letterSpacingSemiBold: [R(U, "em")]
  }),
  boldSmallBody: S(g({}, X), {
    fontFamily: E.primary,
    fontWeight: W,
    fontSize: [
      u,
      u,
      u,
      k,
      k
    ],
    lineHeight: D,
    letterSpacing: R(U, "em")
  }),
  link: S(g({}, X), {
    fontFamily: E.primary,
    fontWeight: W,
    fontSize: [
      l,
      l,
      l,
      h,
      h
    ],
    lineHeight: D,
    letterSpacing: R(lo, "em")
  }),
  smallBodyLink: S(g({}, X), {
    fontFamily: E.primary,
    fontWeight: uo,
    fontSize: [u, u, u, k, k],
    lineHeight: D,
    letterSpacing: R(U, "em")
  })
}, x = {
  secondary: {
    museo100: "Museo100-Regular100",
    museo300: "Museo300-Regular300",
    museo500: "Museo500-Regular500"
  },
  primary: {
    latoBlack: "Lato-Black",
    latoBold: "Lato-Bold",
    latoRegular: "Lato-Regular",
    latoSemibold: "Lato-Semibold"
  }
}, Hr = {
  fontSize: u,
  lineHeight: D * u,
  letterSpacing: U
}, fo = {
  color: y,
  bannerTitle: {
    fontSize: K,
    fontFamily: x.secondary.museo500,
    lineHeight: so * K
  },
  pageTitle: {
    fontSize: z,
    fontFamily: x.primary.latoBlack,
    lineHeight: so * z
  },
  sectionTitle: {
    fontSize: V,
    fontFamily: x.primary.latoBlack,
    lineHeight: so * V
  },
  header: {
    fontFamily: x.primary.latoBold,
    fontSize: L,
    lineHeight: dn * L,
    letterSpacing: co
  },
  boldBody: {
    fontFamily: x.primary.latoBold,
    fontSize: l,
    lineHeight: D * l,
    letterSpacing: lo
  },
  body: {
    fontFamily: x.primary.latoRegular,
    fontSize: l,
    lineHeight: D * l,
    letterSpacing: co,
    color: y
  },
  smallBody: S(g({}, Hr), {
    fontFamily: x.primary.latoRegular
  }),
  smallBodySemiBold: S(g({}, Hr), {
    fontFamily: x.primary.latoSemibold
  }),
  smallBodyBold: {
    fontFamily: x.primary.latoBold,
    fontSize: u,
    lineHeight: D * u,
    letterSpacing: U
  },
  link: {
    fontFamily: x.primary.latoBold,
    fontSize: l,
    lineHeight: D * l,
    letterSpacing: lo,
    color: F,
    textDecorationLine: "underline"
  },
  smallBodyLink: {
    fontFamily: x.primary.latoBold,
    fontSize: u,
    lineHeight: D * u,
    letterSpacing: U,
    textDecorationLine: "underline",
    color: F
  },
  fontBold: {
    fontFamily: x.primary.latoBold
  },
  fontSemibold: {
    fontFamily: x.primary.latoSemibold
  },
  error: {
    color: Mo
  }
};
function Qo(o) {
  return {
    spacingInputPaddingVertical: o.spacingInputMd2,
    spacingInputPaddingVerticalLg: o.spacingInputMd3,
    spacingInputPaddingVerticalActive: o.spacingInputSm2,
    spacingInputPaddingVerticalLgActive: o.spacingInputSm3,
    spacingInputPaddingHorizontal: o.spacingInputMd,
    spacingInputVerticalGap: o.spacingGapSm,
    spacingInputHorizontalGap: o.spacingTextSm,
    spacingInputTextErrorPaddingTop: o.spacingTextXs,
    spacingInputTextHintMessagePaddingTop: o.spacingTextXs,
    spacingInputTextCounterPaddingTop: o.spacingTextXs,
    spacingInputTextCounterPaddingLeft: o.spacingTextMd,
    spacingInputTextLabelPaddingRight: o.spacingTextMd,
    spacingInputTextPointsPaddingHorizontal: o.spacingTextMd,
    spacingInputTextLinkPaddingLeft: o.spacingTextMd,
    spacingInputTextNumberPaddingHorizontal: o.spacingTextMd,
    spacingInputThumbnailPaddingLeft: o.spacingIconMd,
    spacingInputIconPaddingLeft: o.spacingIconMd,
    spacingInputListOptionsPaddingHorizontal: o.spacingInputMd,
    spacingInputListOptionsPaddingVertical: o.spacingInputSm,
    spacingInputListOptionsHorizontalGap: o.spacingGapMd,
    spacingInputListOptionsVerticalGap: o.spacingInputMd,
    spacingInputOptionsPaddingVertical: o.spacingInputSm,
    spacingInputImageFlagPaddingRight: o.spacingInputSm,
    spacingVoucherListViewTextPaddingHorizontal: o.spacingGapMd,
    spacingVoucherListViewTextVerticalGap: o.spacingTextXs,
    spacingVoucherListViewTextPointsPaddingLeft: o.spacingTextXs,
    spacingVoucherListViewNoImageTextPaddingHorizontal: o.spacingGapMd,
    spacingVoucherListViewNoImageTextVerticalGap: o.spacingTextXs,
    spacingVoucherListViewNoImageCheckboxPaddingHorizontal: o.spacingGapXxl,
    spacingRibbonHorizontalGap: o.spacingGapSm,
    spacingVoucherGridViewPaddingHorizontal: o.spacingGapMd,
    spacingVoucherGridViewPaddingVertical: o.spacingGapMd,
    spacingVoucherGridViewTextVerticalGap: o.spacingTextXs,
    spacingVoucherGridViewTextHorizontalGap: o.spacingTextXs,
    spacingVoucherGridViewLabelPaddingBottom: o.spacingTextMd,
    spacingVoucherGridViewLabelPaddingTop: o.spacingTextXs,
    spacingDrawerPaddingHorizontal: o.spacingGapLg,
    spacingDrawerPaddingTop: o.spacingGapLg,
    spacingDrawerVerticalGap: o.spacingGapMd,
    spacingDrawerListOptionPaddingVertical: o.spacingGapSm,
    spacingDrawerListOptionPaddingHorizontal: o.spacingGapLg,
    spacingDrawerListOptionHorizontalGap: o.spacingGapMd,
    spacingDrawerListVerticalGap: o.spacingGapSm,
    spacingDrawerImageFlagPaddingRight: o.spacingGapSm,
    spacingDrawerImageThumbnailPaddingRight: o.spacingGapMd,
    spacingDrawerHeaderPaddingHorizontal: o.spacingGapLg,
    spacingDrawerHeaderPaddingTop: o.spacingGapLg,
    spacingDrawerSearchPaddingHorizontal: o.spacingGapLg,
    spacingDrawerLabelPaddingHorizontal: o.spacingGapLg,
    spacingDrawerLabelPaddingVertical: o.spacingGapMd,
    spacingDrawerHandlePaddingTop: o.spacingGapSm,
    spacingDrawerChipGroupVerticalGap: o.spacingGapMd,
    spacingDrawerChipGroupHorizontalGap: o.spacingGapSm,
    spacingDrawerChipVerticalGap: o.spacingGapMd,
    spacingDrawerChipPaddingBottom: o.spacingGapSm,
    spacingStickyFooterPaddingHorizontal: o.spacingGapLg,
    spacingStickyFooterPaddingVertical: o.spacingGapLg,
    spacingStickyFooterHorizontalGap: o.spacingGapMd,
    spacingStickyFooterVerticalGap: o.spacingGapSm,
    spacingStickyFooterTextLinkVerticalGap: o.spacingGapMd,
    spacingFileInputTextLabelPaddingBottom: o.spacingInputXs,
    spacingFileInputTextLinkPaddingBottom: o.spacingInputXs,
    spacingFileInputTextLinkPaddingLeft: o.spacingInputMd,
    spacingRatingIconHorizontalGap: o.spacingIconXs,
    spacingRatingHorizontalGap: o.spacingGapSm,
    spacingSelectorPaddingHorizontal: o.spacingGapMd,
    spacingSelectorPaddingVertical: o.spacingGapMd,
    spacingSelectorVerticalGap: o.spacingGapMd,
    spacingSelectorHorizontalGap: o.spacingGapMd,
    spacingSelectorVariant6PaddingHorizontal: o.spacingGapSm,
    spacingSelectorVariant6VerticalGap: o.spacingGapXs,
    spacingSelectorVariant6SubtitlePaddingTop: o.spacingTextXs,
    spacingSelectorThumbnailPaddingLeft: o.spacingIconMd,
    spacingSelectorVariant7PaddingHorizontal: o.spacingGapSm,
    spacingSelectorTextUnavailablePaddingTop: o.spacingTextXs,
    spacingSelectorTextSubtitlePaddingTop: o.spacingTextXs,
    spacingSelectorTextPointsPaddingLeft: o.spacingTextMd,
    spacingSelectorTextTagPaddingLeft: o.spacingTextSm,
    spacingToastHorizontalGap: o.spacingGapMd,
    spacingToastPaddingHorizontal: o.spacingGapMd,
    spacingToastPaddingVertical: o.spacingGapMd,
    spacingToastPaddingHorizontalLg: o.spacingGapLg,
    spacingToastPaddingVerticalLg: o.spacingGapLg,
    spacingTextLinkHorizontalGap: o.spacingGapSm,
    spacingTagPaddingHorizontal: o.spacingGapMd,
    spacingTabsVerticalGap: o.spacingGapSm,
    spacingTabsPaddingHorizontal: o.spacingGapLg,
    spacingTabsIconVerticalGap: o.spacingIconXs,
    spacingTablePaddingHorizontal: o.spacingGapMd,
    spacingTablePaddingHorizontalLg: o.spacingGapLg,
    spacingTableCellPaddingVertical: o.spacingGapSm,
    spacingTableCellPaddingVerticalLg: o.spacingGapLg,
    spacingTableCellHorizontalGap: o.spacingGapMd,
    spacingPaginationHorizontalGapSm: o.spacingGapSm,
    spacingPaginationHorizontalGapLg: o.spacingGapLg,
    spacingPaginationIconPaddingHorizontal: o.spacingGapSm2,
    spacingPaginationIconPaddingHorizontalLg: o.spacingGapSm,
    spacingPaginationIconHorizontalGap: o.spacingGapSm,
    spacingPaginationIconPaddingVertical: o.spacingGapSm2,
    spacingPaginationIconPaddingVerticalLg: o.spacingGapSm,
    spacingPaginationTextInputHorizontalGap: o.spacingGapSm,
    spacingNumberedListHorizontalGap: o.spacingGapSm,
    spacingNumberedListHorizontalGapXs: o.spacingGapXs,
    spacingNumberedListVerticalGap: o.spacingGapSm,
    spacingNotificationPaddingHorizontal: o.spacingGapMd,
    spacingNotificationPaddingVertical: o.spacingGapMd,
    spacingNotificationVerticalGap: o.spacingGapSm,
    spacingNotificationHorizontalGap: o.spacingGapSm,
    spacingNotificationPaddingHorizontalLg: o.spacingGapLg,
    spacingNotificationPaddingVerticalLg: o.spacingGapLg,
    spacingNotificationTextLinkPaddingTop: o.spacingTextSm,
    spacingTopNavigationPaddingHorizontal: o.spacingGapLg,
    spacingTopNavigationPaddingBottom: o.spacingGapMd,
    spacingTopNavigationHorizontalGap: o.spacingGapMd,
    spacingTopNavigationIconHorizontalGap: o.spacingIconLg,
    spacingBottomNavigationPaddingVertical: o.spacingGapSm,
    spacingBottomNavigationPaddingHorizontal: o.spacingGapMd,
    spacingModalPaddingHorizontal: o.spacingGapMd,
    spacingModalCardVerticalGap: o.spacingGapMd,
    spacingModalCardPaddingHorizontal: o.spacingGapLg,
    spacingModalCardPaddingTop: o.spacingGapLg,
    spacingModalCardPaddingBottom: o.spacingGapXl,
    spacingModalCardPaddingHorizontalLg: o.spacingGapXl,
    spacingModalCardPaddingHorizontalSm: o.spacingGapXl,
    spacingModalCardPaddingTopLg: o.spacingGapXl,
    spacingModalCardPaddingTopSm: o.spacingGapXl,
    spacingModalCardPaddingBottomLg: o.spacingGapXxl,
    spacingModalCardPaddingBottomSm: o.spacingGapXxl,
    spacingModalIconPaddingLeft: o.spacingIconMd,
    spacingModalButtonPaddingTop: o.spacingGapSm,
    spacingModalButtonStickyPaddingHorizontal: o.spacingGapLg,
    spacingModalButtonStickyPaddingVertical: o.spacingGapLg,
    spacingMapVariant2VerticalGap: o.spacingGapMd,
    spacingMapVariant2IconPaddingLeft: o.spacingGapMd,
    spacingMapVariant2CardPaddingHorizontal: o.spacingGapMd,
    spacingMapVariant2CardPaddingVertical: o.spacingGapMd,
    spacingMapVariant2CardVerticalGap: o.spacingGapMd,
    spacingButtonIconPaddingVerticalLg: o.spacingIconXxs,
    spacingButtonPaddingHorizontal: o.spacingGapLg,
    spacingButtonPaddingVertical: o.spacingGapSm,
    spacingButtonMiniPaddingHorizontal: o.spacingGapMd,
    spacingButtonMiniPaddingVertical: o.spacingGapXs,
    spacingDividerHorizontalGap: o.spacingGapMd,
    spacingListItemTextPaddingHorizontal: o.spacingTextMd,
    spacingListItemIconStatusPaddingRight: o.spacingGapMd,
    spacingListItemLinkPaddingRight: o.spacingGapMd,
    spacingListItemTogglePaddingRight: o.spacingGapMd,
    spacingListItemButtonPaddingLeft: o.spacingGapSm,
    spacingListItemIconPaddingLeft: o.spacingIconSm,
    spacingListItemImagePaddingRight: o.spacingImageMd,
    spacingListItemIconImagePaddingVertical: o.spacingImageMd,
    spacingListItemIconImagePaddingHorizontal: o.spacingImageMd,
    spacingListItemIconIconPaddingVertical: o.spacingIconLg,
    spacingListItemIconIconPaddingHorizontal: o.spacingIconLg,
    spacingListItemImageIconPaddingRight: o.spacingIconXs,
    spacingListItemImagePointsPaddingTop: o.spacingIconXs,
    spacingHeroBannerIndicatorPaddingBottom: o.spacingGapMd,
    spacingHeroBannerIndicatorHorizontalGap: o.spacingGapSm,
    spacingHeroBannerTextPaddingHorizontal: o.spacingGapLg,
    spacingCirclePatternVariant1TextPaddingTop: o.spacingTextMd,
    spacingCirclePatternVariant1VerticalGap: o.spacingGapXxl,
    spacingCirclePatternVariant2TextPaddingLeft: o.spacingTextMd,
    spacingCirclePatternVariant2VerticalGap: o.spacingGapLg,
    spacingCirclePatternVariant2VerticalGapLg: o.spacingGapXl,
    spacingCirclePatternVariant2HorizontalGapLg: o.spacingGapXxxl,
    spacingCarouselIndicatorPaddingTop: o.spacingGapSm,
    spacingCarouselIndicatorHorizontalGap: o.spacingGapSm,
    spacingCarouselIndicatorPaddingTopLg: o.spacingGapMd,
    spacingCarouselPaddingTop: o.spacingGapXxl,
    spacingCarouselPaddingHorizontal: o.spacingGapLg,
    spacingCarouselPaddingHorizontalLg: o.spacingGapXl,
    spacingCarouselTextVerticalGap: o.spacingGapMd,
    spacingBannerPaddingTop: o.spacingGapXl,
    spacingBannerPaddingBottom: o.spacingGapXl,
    spacingBannerPaddingHorizontal: o.spacingGapLg,
    spacingBannerVerticalGap: o.spacingGapSm,
    spacingBannerVerticalGapLg: o.spacingGapMd,
    spacingBannerButtonPaddingTop: o.spacingGapSm,
    spacingBreadcrumbsHorizontalGap: o.spacingGapSm,
    spacingBreadcrumbsDividerPaddingRight: o.spacingGapSm,
    spacingBulletListHorizontalGapSm: o.spacingGapSm,
    spacingBulletListHorizontalGap: o.spacingGapSm2,
    spacingBulletListPaddingLeft: o.spacingGapSm,
    spacingBulletListVerticalGap: o.spacingGapSm,
    spacingBulletListIconPaddingTopXs: o.spacingBulletXs,
    spacingBulletListIconPaddingTopSm: o.spacingBulletSm,
    spacingBulletListIconPaddingTopMd: o.spacingBulletMd,
    spacingAccordionHorizontalGap: o.spacingGapMd,
    spacingAccordionTitlePaddingVertical: o.spacingTextMd,
    spacingAccordionBodyPaddingBottom: o.spacingTextMd,
    spacingAccordionIconPaddingTop: o.spacingIconXs,
    spacingCardBigImagePaddingHorizontal: o.spacingGapMd,
    spacingCardBigImagePaddingHorizontalLg: o.spacingGapLg,
    spacingCardBigImagePaddingTop: o.spacingGapMd,
    spacingCardBigImagePaddingTopLg: o.spacingGapLg,
    spacingCardBigImagePaddingBottom: o.spacingGapLg,
    spacingCardBigImagePaddingBottomLg: o.spacingGapXl,
    spacingCardBigImageTextSubtitleHorizontalGap: o.spacingTextXs,
    spacingCardBigImageTextBodyPaddingTop: o.spacingTextSm,
    spacingCardBigImageButtonPaddingTop: o.spacingGapMd,
    spacingCardProductPaddingHorizontal: o.spacingGapMd,
    spacingCardProductPaddingHorizontalLg: o.spacingGapLg,
    spacingCardProductPaddingTop: o.spacingGapMd,
    spacingCardProductPaddingTopLg: o.spacingGapLg,
    spacingCardProductPaddingBottom: o.spacingGapMd,
    spacingCardProductPaddingBottomLg: o.spacingGapLg,
    spacingCardProductVerticalGap: o.spacingGapMd,
    spacingCardContentPaddingHorizontal: o.spacingGapLg,
    spacingCardContentVerticalGap: o.spacingGapMd,
    spacingCardContentPaddingVertical: o.spacingGapLg,
    spacingCardContentTextTitlePaddingBottom: o.spacingTextSm,
    spacingCardThumbnailPaddingHorizontal: o.spacingGapLg,
    spacingCardThumbnailPaddingVertical: o.spacingGapLg,
    spacingCardThumbnailMultipleHorizontalGap: o.spacingGapSm,
    spacingCardThumbnailVerticalGap: o.spacingGapMd,
    spacingCardThumbnailTextRibbonPaddingBottom: o.spacingTextSm,
    spacingCardCopyClipboardPaddingHorizontal: o.spacingGapLg,
    spacingCardCopyClipboardPaddingVertical: o.spacingGapMd,
    spacingCardCopyClipboardPaddingVerticalLg: o.spacingGapLg,
    spacingCardCopyClipboardHorizontalGap: o.spacingGapMd,
    spacingCardTitleImagePaddingRight: o.spacingGapMd,
    spacingCardPaddingHorizontal: o.spacingGapMd,
    spacingCardPaddingHorizontalLg: o.spacingGapLg,
    spacingCardPaddingHorizontalXl: o.spacingGapXl,
    spacingCardPaddingVertical: o.spacingGapMd,
    spacingCardPaddingVerticalLg: o.spacingGapLg,
    spacingCardPaddingVerticalXl: o.spacingGapXl,
    spacingCardFeatureVerticalGap: o.spacingGapMd,
    spacingCardFeatureTextTitlePaddingLeft: o.spacingTextMd,
    spacingCardButtonPaddingLeft: o.spacingGapMd,
    spacingCardTagPaddingBottom: o.spacingGapSm,
    spacingCardTitleVerticalGap: o.spacingGapSm,
    spacingCardTitleHorizontalGap: o.spacingGapMd,
    spacingCardTitleHorizontalGapXs: o.spacingGapXs,
    spacingCalendarMonthPaddingVertical: o.spacingGapMd,
    spacingCalendarMonthPaddingBottomLg: o.spacingGapSm,
    spacingCalendarDayPaddingVertical: o.spacingGapMd,
    spacingCalendarPaddingVerticalLg: o.spacingGapMd,
    spacingCalendarPaddingHorizontalLg: o.spacingGapMd,
    spacingCalendarPaddingHorizontal: o.spacingGapLg,
    spacingCalendarDatesVerticalGap: o.spacingGapSm,
    spacingCalendarButtonPaddingLeft: o.spacingGapLg,
    spacingChipPaddingHorizontal: o.spacingGapMd,
    spacingChipPaddingVertical: o.spacingGapXs,
    spacingChipTextLinkPaddingVertical: o.spacingGapXs,
    spacingChipTextLinkPaddingHorizontal: o.spacingGapSm,
    spacingIconButtonPaddingHorizontal: o.spacingGapSm,
    spacingIconButtonHorizontalGap: o.spacingGapSm,
    spacingIconButtonPaddingVertical: o.spacingGapSm,
    spacingIconButtonPaddingHorizontalSm: o.spacingGapXs,
    spacingIconButtonHorizontalGapSm: o.spacingGapMd,
    spacingIconButtonPaddingVerticalSm: o.spacingGapXs,
    spacingCardIconListHorizontalGap: o.spacingGapSm,
    spacingCardFooterVerticalGap: o.spacingGapMd,
    spacingCardFooterHorizontalGap: o.spacingGapMd,
    spacingCardBodyVerticalGap: o.spacingGapSm,
    spacingSwimlaneHorizontalGapSm: o.spacingGapSm,
    spacingSwimlaneHorizontalGapMd: o.spacingGapMd,
    colourTagText: o.colourTextInverse,
    colourTagBackgroundPrimary: o.colourTagPrimary,
    colourTagBackgroundSecondary: o.colourTagSecondary,
    colourNotificationTextTitle: o.colourTextNeutral,
    colourNotificationTextBody: o.colourTextNeutral,
    colourNotificationBackgroundAlert: o.colourNotificationAlert,
    colourNotificationBackgroundInfo: o.colourNotificationDefault,
    colourNotificationBackgroundPromo: o.colourNotificationPromo,
    colourNotificationIcon: o.colourIconNeutral,
    colourToggleOn: o.colourToggleActiveStrong,
    colourToggleBaseActive: o.colourToggleActiveWeak,
    colourToggleOff: o.colourToggleInactiveStrong,
    colourToggleBase: o.colourToggleInactiveWeak,
    colourRibbonIconBackgroundPrimary: o.colourRibbonPrimary2,
    colourRibbonIconBackgroundSecondary: o.colourRibbonSecondary2,
    colourRibbonIconPrimary: o.colourRibbonPrimary3,
    colourRibbonIconSecondary: o.colourRibbonSecondary,
    colourRibbonTextPrimary: o.colourRibbonPrimary,
    colourRibbonTextSecondary: o.colourRibbonSecondary,
    colourVoucherBackground: o.colourBackgroundStandard,
    colourVoucherBackgroundRedeemed: o.colourBackgroundDisabled,
    colourVoucherTextTitle: o.colourTextNeutral,
    colourVoucherTextSubtitle: o.colourTextSubtle,
    colourVoucherTextPoints: o.colourTextNeutral,
    colourVoucherTextPointsRedeemed: o.colourTextSubtle,
    colourVoucherTextSubtitleRedeemed: o.colourTextSubtle,
    colourVoucherTextTitleRedeemed: o.colourTextNeutral,
    colourVoucherTextSubtitleExpiring: o.colourTextAlert,
    colourVoucherTextPointsStrikethrough: o.colourTextStrikethrough,
    colourVoucherIcon: o.colourIconSubtle,
    colourDrawerBackgroundOverlay: o.colourBackgroundOverlay,
    colourDrawerBackgroundStandard: o.colourBackgroundStandard,
    colourDrawerBackgroundSelected: o.colourBackgroundSelected,
    colourDrawerBackgroundLabel: o.colourBackgroundSubtle,
    colourDrawerTextHeader: o.colourTextNeutral,
    colourDrawerTextHint: o.colourTextLabel,
    colourDrawerTextTitlePinned: o.colourTextNeutral,
    colourDrawerTextTitle: o.colourTextNeutral,
    colourDrawerTextSubtitle: o.colourTextSubtle,
    colourDrawerTextStrikethrough: o.colourTextStrikethrough,
    colourDrawerTextLabel: o.colourTextLabel,
    colourDrawerTextError: o.colourTextAlert,
    colourDrawerTextLink: o.colourTextLink,
    colourDrawerIcon: o.colourIconSubtle,
    colourDrawerHandle: o.colourIconWeak,
    colourButtonSecondaryBorderInverse: o.colourBorderCtaInverse,
    colourButtonSecondaryBorder: o.colourBorderCta,
    colourButtonIconPrimary: o.colourIconCtaInverse,
    colourButtonIconPrimaryInverse: o.colourIconCta,
    colourButtonIconSecondaryInverse: o.colourIconCtaInverse,
    colourButtonIconSecondary: o.colourIconCta,
    colourButtonIconSuccess: o.colourIconInverse,
    colourButtonTextPrimary: o.colourTextCtaInverse,
    colourButtonTextPrimaryInverse: o.colourTextCta,
    colourButtonTextSecondary: o.colourTextCta,
    colourButtonTextSecondaryInverse: o.colourTextCtaInverse,
    colourButtonBackgroundPrimary: o.colourBackgroundCta,
    colourButtonBackgroundPrimaryPressed: o.colourBackgroundCtaPressed,
    colourButtonBackgroundPrimaryInverse: o.colourBackgroundCtaInverse,
    colourButtonBackgroundPrimaryInversePressed: o.colourBackgroundCtaInversePressed,
    colourButtonBackgroundSuccess: o.colourBackgroundCtaSuccess,
    colourStickyFooterText: o.colourTextNeutral,
    colourStickyFooterPrice: o.colourTextNeutral,
    colourStickyFooterPriceStrikethrough: o.colourTextStrikethrough,
    colourStickyFooterBorderTop: o.colourBorderWeak,
    colourStickyFooterBackground: o.colourBackgroundStandard,
    colourInputBackground: o.colourBackgroundStandard,
    colourInputBackgroundHaze: o.colourBackgroundSubtle,
    colourInputBackgroundSelected: o.colourBackgroundSelected,
    colourInputBackgroundHover: o.colourBackgroundHover,
    colourInputBorderActive: o.colourBorderActive,
    colourInputBorderError: o.colourBorderError,
    colourInputBorderStandard: o.colourBorderStandard,
    colourInputTextLabel: o.colourTextNeutral,
    colourInputTextLabelActive: o.colourTextLabel,
    colourInputTextHint: o.colourTextLabel,
    colourInputTextHintMessage: o.colourTextNeutral,
    colourInputTextPlaceholder: o.colourTextLabel,
    colourInputTextActive: o.colourTextNeutral,
    colourInputTextLink: o.colourTextLink,
    colourInputTextError: o.colourTextAlert,
    colourInputTextCounter: o.colourTextLabel,
    colourInputTextSuccess: o.colourTextSuccess,
    colourInputTextLoading: o.colourTextDisabled,
    colourInputTextOptions: o.colourTextNeutral,
    colourInputTextSearchString: o.colourTextNeutral,
    colourInputTextNonsearchString: o.colourTextLabel,
    colourInputTextNumber: o.colourTextNeutral,
    colourInputIconLoader: o.colourIconLoader,
    colourInputIconSuccess: o.colourIconSuccess,
    colourInputIconInverse: o.colourIconInverse,
    colourInputIconBackgroundActive: o.colourIconCta,
    colourInputIconBackgroundDisabled: o.colourIconDisabled,
    colourInputIconStandard: o.colourIconSubtle,
    colourRatingText: o.colourTextLabel,
    colourRatingIconActive: o.colourIconRating,
    colourRatingIconBase: o.colourIconDisabled,
    colourCheckboxInputBorderError: o.colourBorderError,
    colourCheckboxInputBorderStandard: o.colourBorderStandard,
    colourCheckboxInputBorderHover: o.colourBorderActive,
    colourCheckboxInputBackgroundStandard: o.colourBackgroundStandard,
    colourCheckboxInputBackgroundActive: o.colourBackgroundActive,
    colourRadioInputBackgroundStandard: o.colourBackgroundStandard,
    colourRadioInputBackgroundActive: o.colourBackgroundActive,
    colourRadioInputBorderError: o.colourBorderError,
    colourRadioInputBorderStandard: o.colourBorderStandard,
    colourRadioInputBorderHover: o.colourBorderActive,
    colourSelectorBackground: o.colourBackgroundStandard,
    colourSelectorBackgroundSubtle: o.colourBackgroundSubtle,
    colourSelectorBorderActive: o.colourBorderActive,
    colourSelectorBorderStandard: o.colourBorderStandard,
    colourSelectorBorderDisabled: o.colourBorderDisabled,
    colourSelectorTextTitle: o.colourTextNeutral,
    colourSelectorTextBody: o.colourTextNeutral,
    colourSelectorTextPrice: o.colourTextNeutral,
    colourSelectorTextSubtitle: o.colourTextSubtle,
    colourSelectorTextStrikethrough: o.colourTextStrikethrough,
    colourSelectorTextDisabled: o.colourTextDisabled,
    colourSelectorTextUnavailable: o.colourTextNeutral,
    colourSelectorColourIndicatorBorderInner: o.colourBorderWeak,
    colourSelectorColourIndicatorBorderOuter: o.colourBorderStandard,
    colourSelectorColourIndicatorStrikeout: o.colourBorderStrikeout,
    colourSelectorColourIndicatorStrikeoutInverse: o.colourBorderStrikeoutInverse,
    colourToastTextInverse: o.colourTextInverse,
    colourToastIconAlert: o.colourIconAlertInverse,
    colourToastIconSuccess: o.colourIconSuccess,
    colourToastIconPending: o.colourIconPending,
    colourToastTextLinkInverse: o.colourTextLinkInverse,
    colourToastBackground: o.colourBackgroundDark,
    colourTextLinkText: o.colourTextLink,
    colourTextLinkTextInverse: o.colourTextLinkInverse,
    colourTextLinkIcon: o.colourIconLink,
    colourTextLinkIconInverse: o.colourIconLinkInverse,
    colourTabsTextTitle: o.colourTextLink,
    colourTabsTextTitleInverse: o.colourTextCtaInverse,
    colourTabsTextSubtitle: o.colourTextLink,
    colourTabsTextSubtitleInverse: o.colourTextCtaInverse,
    colourTabsTextTitleInactive: o.colourTextSubtle,
    colourTabsTextTitleInverseInactive: o.colourTextSubtleInverse,
    colourTabsTextSubtitleInactive: o.colourTextSubtle,
    colourTabsTextSubtitleInverseInactive: o.colourTextSubtleInverse,
    colourTabsBorderActive: o.colourBorderActive,
    colourTabsBorderActiveInverse: o.colourBorderActiveInverse,
    colourTabsBorderInactive: o.colourBorderWeak,
    colourTabsBorderInactiveInverse: o.colourBorderWeakInverse,
    colourTabsIconActive: o.colourIconLink,
    colourTabsIconActiveInverse: o.colourIconCtaInverse,
    colourTabsIconInactive: o.colourIconSubtle,
    colourTabsIconInactiveInverse: o.colourIconSubtleInverse,
    colourTableText: o.colourTextNeutral,
    colourTableBackground: o.colourBackgroundStandard,
    colourTableCellHover: o.colourBackgroundHover,
    colourTableCellSelected: o.colourBackgroundSelected,
    colourStepperTextInactive: o.colourTextLabel,
    colourStepperTextActive: o.colourTextInverse,
    colourStepperTextLabel: o.colourTextSubtle,
    colourStepperBackgroundActive: o.colourBackgroundActive,
    colourStepperBackgroundInactive: o.colourIconInactive,
    colourStepperBackgroundSuccess: o.colourIconActive,
    colourStepperIconSuccess: o.colourIconInverse,
    colourStepperBorderActive: o.colourBorderActive,
    colourStepperConnectorSuccess: o.colourBorderStrong,
    colourStepperConnectorInactive: o.colourBorderWeak,
    colourPaginationText: o.colourTextNeutral,
    colourPaginationIcon: o.colourIconSubtle,
    colourPaginationBackgroundHover: o.colourBackgroundHover,
    colourNumberedListText: o.colourTextNeutral,
    colourTopNavigationTextStandard: o.colourTextNeutral,
    colourTopNavigationTextInverse: o.colourTextInverse,
    colourTopNavigationIconStandard: o.colourIconNeutral,
    colourTopNavigationIconInverse: o.colourIconInverse,
    colourTopNavigationGradient: o.colourGradientNeutral,
    colourTopNavigationBackground: o.colourBackgroundStandard,
    colourTopNavigationBackgroundHaze: o.colourBackgroundSubtle,
    colourTopNavigationBorderBottom: o.colourBorderWeak,
    colourBottomNavigationTextInactive: o.colourTextLabel,
    colourBottomNavigationTextActive: o.colourTextNavigationActive,
    colourBottomNavigationIconInactive: o.colourIconBottomNavigationInactive,
    colourBottomNavigationIconActive: o.colourIconBottomNavigationActive,
    colourBottomNavigationBackground: o.colourBackgroundStandard,
    colourBottomNavigationBorderTop: o.colourBorderWeak,
    colourModalTextHeader: o.colourTextNeutral,
    colourModalTextBody: o.colourTextNeutral,
    colourModalBackground: o.colourBackgroundStandard,
    colourModalOverlay: o.colourBackgroundOverlay,
    colourModalIcon: o.colourIconNeutral,
    colourLocationPinDefault: o.colourIconLocationPin,
    colourLocationPinActive: o.colourIconLocationPinActive,
    colourLocationPinText: o.colourTextNeutral,
    colourLocationPinTextBorder: o.colourTextInverse,
    colourMapVariant2Icon: o.colourIconNeutral,
    colourMapVariant2TextResults: o.colourTextNeutral,
    colourMapVariant2CardTextTitle: o.colourTextNeutral,
    colourMapVariant2CardTextSubtitle: o.colourTextSubtle,
    colourListItemBackground: o.colourBackgroundStandard,
    colourListItemIconBackground: o.colourBackgroundSubtle,
    colourListItemTextTitle: o.colourTextNeutral,
    colourListItemTextSubtitle: o.colourTextSubtle,
    colourListItemTextPoints: o.colourTextNeutral,
    colourListItemIcon: o.colourIconNeutral,
    colourListItemIconSubtle: o.colourIconSubtle,
    colourHeroBannerTextTitle: o.colourTextNeutral,
    colourHeroBannerTextTitleInverse: o.colourTextInverse,
    colourHeroBannerTextSubtitle: o.colourTextNeutral,
    colourHeroBannerTextSubtitleInverse: o.colourTextInverse,
    colourHeroBannerIndicatorInactive: o.colourIconInactive,
    colourHeroBannerIndicatorActive: o.colourIconActive,
    colourCirclePatternTextHeader: o.colourTextNeutral,
    colourCirclePatternTextTitle: o.colourTextNeutral,
    colourCirclePatternTextBody: o.colourTextNeutral,
    colourCarouselTextTitle: o.colourTextNeutral,
    colourCarouselTextTitleInverse: o.colourTextInverse,
    colourCarouselTextBody: o.colourTextNeutral,
    colourCarouselTextBodyInverse: o.colourTextInverse,
    colourCarouselIndicatorActive: o.colourIconActive,
    colourCarouselIndicatorInactive: o.colourIconInactive,
    colourCarouselArrowIcon: o.colourIconNeutral,
    colourCarouselArrowBackground: o.colourIconInactive,
    colourCarouselOverlay: o.colourBackgroundOverlayLight,
    colourBannerBackground: o.colourBackgroundSubtle,
    colourBannerTextTitle: o.colourTextNeutral,
    colourBannerTextBody: o.colourTextNeutral,
    colourBreadcrumbsTextCurrentPage: o.colourTextNeutral,
    colourBreadcrumbsTextPages: o.colourTextLabel,
    colourBreadcrumbsTextTruncation: o.colourTextLabel,
    colourBreadcrumbsDivider: o.colourTextLabel,
    colourBulletListText: o.colourTextNeutral,
    colourBulletListIcon: o.colourTextNeutral,
    colourAccordionIcon: o.colourIconSubtle,
    colourAccordionTextTitle: o.colourTextNeutral,
    colourAccordionTextBody: o.colourTextNeutral,
    colourCardTextTitle: o.colourTextNeutral,
    colourCardTextSubtitle: o.colourTextSubtle,
    colourCardTextBody: o.colourTextNeutral,
    colourCardTextPrice: o.colourTextNeutral,
    colourCardTextPriceStrikethrough: o.colourTextStrikethrough,
    colourCardTextLink: o.colourTextLink,
    colourCardTextHeader: o.colourTextInverse,
    colourCardTextSubheader: o.colourTextInverse,
    colourCardTextHeaderDark: o.colourTextNeutral,
    colourCardIconSubtitle: o.colourIconSubtle,
    colourCardIconTitle: o.colourIconNeutral,
    colourCardBackground: o.colourBackgroundStandard,
    colourCardOverlay: o.colourGradientNeutral,
    colourCardOverlayLight: o.colourBackgroundOverlayLight,
    colourCardBorder: o.colourBorderWeak,
    colourCardHeaderTitle: o.colourTextNeutral,
    colourCardHeaderSubtitle: o.colourTextSubtle,
    colourCalendarTextDay: o.colourTextNeutral,
    colourCalendarTextMonth: o.colourTextNeutral,
    colourCalendarTextDate: o.colourTextNeutral,
    colourCalendarTextDateStrikethrough: o.colourTextDisabled,
    colourCalendarTextDateSelected: o.colourTextInverse,
    colourCalendarBackgroundSelected: o.colourBackgroundActive,
    colourCalendarBackgroundSelectedRange: o.colourBackgroundSelected,
    colourCalendarBackgroundDay: o.colourBackgroundSubtle,
    colourCalendarIcon: o.colourIconSubtle,
    colourChipBackgroundStandard: o.colourBackgroundStandard,
    colourChipBackgroundActive: o.colourBackgroundSelected,
    colourChipBorderActive: o.colourBorderActive,
    colourChipBorderStandard: o.colourBorderStandard,
    colourChipTextActive: o.colourTextNeutral,
    colourChipTextInactive: o.colourTextSubtle,
    colourChipIcon: o.colourIconSubtle,
    colourGraphBackgroundActiveStrong: o.colourBackgroundActive,
    colourGraphBackgroundActiveWeak: o.colourBackgroundActiveWeak,
    colourGraphBackgroundData: o.colourBackgroundDark,
    colourGraphBackgroundDataInverse: o.colourBackgroundStandard,
    colourGraphBackgroundActiveStrongInverse: o.colourBackgroundActiveInverse,
    colourGraphBackgroundActiveWeakInverse: o.colourBackgroundActiveWeakInverse,
    colourGraphBorderBenchmark: o.colourBorderBenchmark,
    colourGraphBorderBenchmarkInverse: o.colourBorderBenchmarkInverse,
    colourGraphBorderAxis: o.colourBorderStandard,
    colourGraphBorderGridLine: o.colourBorderStandard,
    colourGraphTextData: o.colourTextInverse,
    colourGraphTextDataInverse: o.colourTextNeutral,
    colourGraphTextAxisLabel: o.colourTextSubtle,
    colourGraphTextAxisLabelInverse: o.colourTextSubtleInverse,
    colourCardIconListThumbnailBorder: o.colourBorderStandard,
    colourCardIconListThumbnailBackground: o.colourBackgroundSubtle,
    colourIconButtonIcon: o.colourIconCta,
    sizingTagShort: o.sizingTagSm,
    sizingTagTall: o.sizingTagMd,
    sizingTagTallLg: o.sizingTagLg,
    sizingVoucherImage: o.sizingVoucherSm,
    sizingVoucherImageLg: o.sizingVoucherMd,
    sizingVoucherHeight: o.sizingVoucherSm,
    sizingVoucherHeightLg: o.sizingVoucherMd,
    sizingVoucherIcon: o.sizingIconGeneralXs,
    sizingVoucherIconLg: o.sizingIconGeneralSm,
    sizingCirclePatternVariant1: o.sizingCirclePatternMd,
    sizingCirclePatternVariant1Lg: o.sizingCirclePatternLg,
    sizingCirclePatternVariant2: o.sizingCirclePatternXs,
    sizingCirclePatternVariant2Lg: o.sizingCirclePatternSm,
    sizingRibbonIconBackground: o.sizingIconGeneralLg,
    sizingRibbonIcon: o.sizingIconGeneralSm,
    sizingDrawerImageFlag: o.sizingImageXxs,
    sizingDrawerImageThumbnail: o.sizingImageLg,
    sizingDrawerHandle: o.sizingIconGeneralXl,
    sizingInputIcon: o.sizingIconUtilityXs,
    sizingInputIconLg: o.sizingIconGeneralSm,
    sizingInputIconUtilityLg: o.sizingIconGeneralSm,
    sizingInputThumbnail: o.sizingImageSm,
    sizingInputIconUtility: o.sizingIconUtilityXs,
    sizingInputImageFlag: o.sizingImageXxs,
    sizingInputImageFlagLg: o.sizingImageXs,
    sizingSelectorThumbnail: o.sizingImageSm,
    sizingSelectorVariant6Thumbnail: o.sizingImageMd,
    sizingToastIcon: o.sizingIconUtilitySm,
    sizingToastTextHeight: o.sizingTextBoxSm,
    sizingTextLinkIconLeft: o.sizingIconGeneralSm,
    sizingTextLinkIconRight: o.sizingIconUtilityXs,
    sizingTextLinkIconRightLg: o.sizingIconUtilityXs2,
    sizingTabsIcon: o.sizingIconGeneralSm,
    sizingStepperInner: o.sizingIconGeneralSm,
    sizingStepperOuter: o.sizingIconGeneralMd,
    sizingStepperOuterLg: o.sizingIconGeneralLg,
    sizingStepperInnerLg: o.sizingIconGeneralMd,
    sizingPaginationIcon: o.sizingIconUtilitySm,
    sizingPaginationIconXs: o.sizingIconUtilityXs,
    sizingPaginationBackground: o.sizingIconGeneralMd,
    sizingPaginationBackgroundLg: o.sizingIconGeneralLg,
    sizingNotificationIcon: o.sizingIconUtilitySm,
    sizingTopNavigationIcon: o.sizingIconGeneralSm,
    sizingBottomNavigationIcon: o.sizingIconGeneralSm,
    sizingBottomNavigationTextWidth: o.sizingTextBoxMd,
    sizingModalIcon: o.sizingIconUtilitySm,
    sizingLocationPinDefault: o.sizingIconUtilitySm,
    sizingLocationPinActive: o.sizingIconUtilityLg,
    sizingMapVariant2Icon: o.sizingIconGeneralSm,
    sizingButtonIcon: o.sizingIconGeneralSm,
    sizingListItemIconImage: o.sizingImageMd,
    sizingListItemIconIcon: o.sizingIconGeneralMd,
    sizingListItemIconIconStatus: o.sizingIconGeneralSm,
    sizingListItemImageImage: o.sizingImageXxl,
    sizingListItemImageIcon: o.sizingIconGeneralXs,
    sizingListItemImageIconLg: o.sizingIconGeneralXs2,
    sizingListItemImageThumbnail: o.sizingImageLg,
    sizingListItemIcon: o.sizingIconUtilityXs,
    sizingListItemIconLg: o.sizingIconUtilitySm,
    sizingCarouselIcon: o.sizingIconUtilitySm,
    sizingCarouselIconBackground: o.sizingIconUtilityLg,
    sizingBannerIcon: o.sizingIconSpotXs,
    sizingBannerIconLg: o.sizingIconSpotLg,
    sizingBulletListIcon: o.sizingBullet,
    sizingBulletListIconSm: o.sizingBulletSm,
    sizingAccordionIcon: o.sizingIconUtilityXs,
    sizingAccordionIconLg: o.sizingIconUtilitySm,
    sizingCardIconSubtitle: o.sizingIconGeneralXs,
    sizingCardIconSubtitleLg: o.sizingIconGeneralXs2,
    sizingCardIconTitle: o.sizingIconGeneralSm,
    sizingCardThumbnailMd: o.sizingImageMd,
    sizingCardThumbnailLg: o.sizingImageLg,
    sizingCardThumbnailXl: o.sizingImageXl,
    sizingCalendarDate: o.sizingTextBoxXs,
    sizingCalendarDay: o.sizingTextBoxXs,
    sizingChipIconClose: o.sizingIconUtilityXxs,
    sizingIconButtonIconMedium: o.sizingIconGeneralSm,
    sizingIconButtonIconSmall: o.sizingIconGeneralXs,
    borderWidthInputStandard: o.borderWidthStandard,
    borderWidthDividerStandard: o.borderWidthStandard,
    borderWidthSelectorStandard: o.borderWidthStandard,
    borderWidthSelectorActive: o.borderWidthSelected,
    borderWidthSelectorStrikeout: o.borderWidthStrikeout,
    borderWidthTabsStandard: o.borderWidthSelected,
    borderWidthTabsActive: o.borderWidthSelected,
    borderWidthStepperActive: o.borderWidthSelected,
    borderWidthStepperConnector: o.borderWidthStandard,
    borderWidthButtonSecondary: o.borderWidthCta,
    borderWidthChip: o.borderWidthStandard,
    borderFileInput: o.borderUpload,
    shadowVoucherLow: o.shadow1,
    shadowTable: o.shadowLow,
    shadowToggle: o.shadowLow,
    shadowTopNavigation: o.shadowLow,
    shadowListItem: o.shadowLow,
    shadowCardLow: o.shadowLow,
    shadowCardHigh: o.shadowHigh,
    borderRadiusDrawerTopLeft: o.borderRadiusMd,
    borderRadiusDrawerTopRight: o.borderRadiusMd,
    borderRadiusButton: o.borderRadiusXl,
    borderRadiusCarouselFixed: o.borderRadiusSm,
    borderRadiusCarouselFixedLg: o.borderRadiusMd,
    borderRadiusInput: o.borderRadiusSm,
    borderRadiusSelector: o.borderRadiusSm,
    borderRadiusToast: o.borderRadiusSm,
    borderRadiusTag: o.borderRadiusSm,
    borderRadiusTable: o.borderRadiusSm,
    borderRadiusTableLg: o.borderRadiusMd,
    borderRadiusNotification: o.borderRadiusSm,
    borderRadiusModal: o.borderRadiusMd,
    borderRadiusVoucher: o.borderRadiusSm,
    borderRadiusChip: o.borderRadiusXl,
    borderRadiusListItem: o.borderRadiusSm,
    borderRadiusCardBigImage: o.borderRadiusMd,
    borderRadiusCardProduct: o.borderRadiusMd,
    borderRadiusCardContent: o.borderRadiusSm,
    borderRadiusCardCopyClipboard: o.borderRadiusSm,
    borderRadiusCardSm: o.borderRadiusSm,
    borderRadiusCardMd: o.borderRadiusMd,
    borderRadiusCardLg: o.borderRadiusLg,
    borderRadiusCardThumbnail: o.borderRadiusSm,
    colourBackgroundDisabled: o.opacityOverlay,
    colourDivider10Horizontal: o.colourDivider,
    colourDivider10Text: o.colourTextSubtle
  };
}
const Ld = "rgba(255,255,255,0.5)", Gd = "rgba(34,34,34,0.5)", Hd = "rgba(18,18,18,0.8)", Vd = "rgba(225,225,225,0.8)", _d = "linear-gradient(180deg, rgba(0, 0, 0, 0.80) 0%, rgba(0, 0, 0, 0.00) 100%);", Ad = 218, Rd = 227, $d = C, Md = f, Dd = f * 1.5, wd = M, Fd = oo, Nd = Yo, Od = Zo, Wd = Sn, Xd = C / 2.666, Ed = C, jd = f, Ud = M, Kd = oo, qd = C, Jd = f, Yd = M, Zd = oo, Qd = Yo, ou = Zo, ru = C, nu = f, eu = f * 1.375, au = f * 1.5, iu = M, tu = f * 2.5, cu = f * 2.8125, lu = C, du = f, uu = M, su = oo, gu = C * 1.75, pu = C * 2.25, Iu = C * 2.5, bu = Jo, Tu = qo, Su = qo, xu = Jo, Bu = Pd, mu = y, hu = p, Cu = p, vu = w, zu = Uo, fu = Uo, ku = F, Pu = F, yu = mo, Lu = mo, Gu = io, Hu = jo, Vu = P, _u = A, Au = y, Ru = ko, $u = G, Mu = G, Du = A, wu = p, Fu = F, Nu = p, Ou = Bo, Wu = yo, Xu = io, Eu = y, ju = p, Uu = P, Ku = F, qu = y, Ju = y, Yu = G, Zu = A, Qu = P, os = Bo, rs = nn, ns = io, es = Lo, as = Lo, is = p, ts = p, cs = P, ls = G, ds = Go, us = F, ss = G, gs = J, ps = G, Is = yo, bs = p, Ts = P, Ss = ao, xs = en, Bs = an, ms = y, hs = p, Cs = Bo, vs = F, zs = A, fs = F, ks = tn, Ps = P, ys = P, Ls = p, Gs = G, Hs = p, Vs = p, _s = Go, As = Go, Rs = tr, $s = Uo, Ms = w, Ds = y, ws = A, Fs = A, Ns = P, Os = ao, Ws = ao, Xs = p, Es = en, js = mo, Us = m * 1.5, Ks = ho, qs = m * 2.5, Js = Y, Ys = Z, Zs = Q, Qs = ho, og = ho * 1.25, rg = Y, ng = Z, eg = Q, ag = j, ig = j, tg = Co, cg = In, lg = vo, dg = bn, ug = Tn, sg = m * 2.5, gg = Y, pg = Z, Ig = m * 13, bg = m * 17.75, Tg = Y, Sg = Z, xg = Q, Bg = j, mg = Co, hg = vo, Cg = m * 13, vg = Q, zg = j, fg = Co, kg = m * 11, Pg = m * 23.5, yg = m * 26.875, Lg = m * 30.25, Gg = m / 1.3333, Hg = m / 2, Vg = Eo, _g = xo, Ag = xo, Rg = Eo, $g = xo, Mg = Zr, Dg = un, wg = gn, Fg = pn, Ng = go, Og = Qr, Wg = on, Xg = rn, xn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  borderRadiusLg: Wg,
  borderRadiusMd: Og,
  borderRadiusSm: Ng,
  borderRadiusXl: Xg,
  borderUpload: Mg,
  borderWidthCta: _g,
  borderWidthHover: Rg,
  borderWidthSelected: Ag,
  borderWidthStandard: Vg,
  borderWidthStrikeout: $g,
  colourBackgroundActive: ku,
  colourBackgroundActiveInverse: Pu,
  colourBackgroundActiveWeak: yu,
  colourBackgroundActiveWeakInverse: Lu,
  colourBackgroundCta: mu,
  colourBackgroundCtaInverse: hu,
  colourBackgroundCtaInversePressed: Ld,
  colourBackgroundCtaPressed: Gd,
  colourBackgroundCtaSuccess: Gu,
  colourBackgroundDark: Hu,
  colourBackgroundDisabled: Vu,
  colourBackgroundHover: zu,
  colourBackgroundOverlay: Hd,
  colourBackgroundOverlayLight: Vd,
  colourBackgroundSelected: fu,
  colourBackgroundStandard: Cu,
  colourBackgroundSubtle: vu,
  colourBackgroundWeak: _u,
  colourBorderActive: fs,
  colourBorderActiveInverse: Vs,
  colourBorderBenchmark: _s,
  colourBorderBenchmarkInverse: As,
  colourBorderCta: ms,
  colourBorderCtaInverse: hs,
  colourBorderDisabled: ks,
  colourBorderError: Cs,
  colourBorderSelected: vs,
  colourBorderStandard: zs,
  colourBorderStrikeout: ys,
  colourBorderStrikeoutInverse: Ls,
  colourBorderStrong: Gs,
  colourBorderWeak: Ps,
  colourBorderWeakInverse: Hs,
  colourDivider: Bs,
  colourGradientNeutral: _d,
  colourIconActive: ls,
  colourIconAlert: os,
  colourIconAlertInverse: rs,
  colourIconBottomNavigationActive: Is,
  colourIconBottomNavigationInactive: ps,
  colourIconCta: Ju,
  colourIconCtaInverse: is,
  colourIconDisabled: Qu,
  colourIconInactive: cs,
  colourIconInverse: ts,
  colourIconLink: Ku,
  colourIconLinkInverse: bs,
  colourIconLoader: ss,
  colourIconLocationPin: ds,
  colourIconLocationPinActive: us,
  colourIconNeutral: qu,
  colourIconNotice: gs,
  colourIconPending: es,
  colourIconRating: as,
  colourIconSubtle: Yu,
  colourIconSubtleInverse: Ts,
  colourIconSuccess: ns,
  colourIconWeak: Zu,
  colourNotificationAlert: Rs,
  colourNotificationDefault: Ms,
  colourNotificationPromo: $s,
  colourRibbonPrimary: Os,
  colourRibbonPrimary2: Ws,
  colourRibbonPrimary3: Xs,
  colourRibbonSecondary: Es,
  colourRibbonSecondary2: js,
  colourTagPrimary: Ss,
  colourTagSecondary: xs,
  colourTextAlert: Ou,
  colourTextCta: Eu,
  colourTextCtaInverse: ju,
  colourTextDisabled: Du,
  colourTextInverse: wu,
  colourTextLabel: $u,
  colourTextLink: Fu,
  colourTextLinkInverse: Nu,
  colourTextNavigationActive: Wu,
  colourTextNeutral: Au,
  colourTextStrikethrough: Mu,
  colourTextSubtle: Ru,
  colourTextSubtleInverse: Uu,
  colourTextSuccess: Xu,
  colourToggleActiveStrong: Ds,
  colourToggleActiveWeak: ws,
  colourToggleInactiveStrong: Fs,
  colourToggleInactiveWeak: Ns,
  opacityDisabled: Su,
  opacityHover: bu,
  opacityOverlay: xu,
  opacityPressed: Tu,
  opacitySubtle: Bu,
  shadowHigh: wg,
  shadowHighInverse: Fg,
  shadowLow: Dg,
  sizingBullet: Gg,
  sizingBulletSm: Hg,
  sizingCirclePatternLg: Lg,
  sizingCirclePatternMd: yg,
  sizingCirclePatternSm: Pg,
  sizingCirclePatternXs: kg,
  sizingFileInput: Ad,
  sizingFileInputLg: Rd,
  sizingIconGeneralLg: eg,
  sizingIconGeneralMd: ng,
  sizingIconGeneralSm: rg,
  sizingIconGeneralXl: ag,
  sizingIconGeneralXs: Qs,
  sizingIconGeneralXs2: og,
  sizingIconSpotLg: lg,
  sizingIconSpotMd: cg,
  sizingIconSpotSm: tg,
  sizingIconSpotXl: dg,
  sizingIconSpotXs: ig,
  sizingIconSpotXxl: ug,
  sizingIconUtilityLg: Zs,
  sizingIconUtilityMd: Ys,
  sizingIconUtilitySm: Js,
  sizingIconUtilityXs: Ks,
  sizingIconUtilityXs2: qs,
  sizingIconUtilityXxs: Us,
  sizingImageLg: mg,
  sizingImageMd: Bg,
  sizingImageSm: xg,
  sizingImageXl: hg,
  sizingImageXs: Sg,
  sizingImageXxl: Cg,
  sizingImageXxs: Tg,
  sizingTagLg: pg,
  sizingTagMd: gg,
  sizingTagSm: sg,
  sizingTextBoxMd: fg,
  sizingTextBoxSm: zg,
  sizingTextBoxXs: vg,
  sizingVoucherMd: bg,
  sizingVoucherSm: Ig,
  spacingBulletMd: Iu,
  spacingBulletSm: pu,
  spacingBulletXs: gu,
  spacingGapLg: Fd,
  spacingGapMd: wd,
  spacingGapSm: Md,
  spacingGapSm2: Dd,
  spacingGapXl: Nd,
  spacingGapXs: $d,
  spacingGapXxl: Od,
  spacingGapXxxl: Wd,
  spacingIconLg: Kd,
  spacingIconMd: Ud,
  spacingIconSm: jd,
  spacingIconXs: Ed,
  spacingIconXxs: Xd,
  spacingImageLg: su,
  spacingImageMd: uu,
  spacingImageSm: du,
  spacingImageXs: lu,
  spacingInputMd: iu,
  spacingInputMd2: tu,
  spacingInputMd3: cu,
  spacingInputSm: nu,
  spacingInputSm2: eu,
  spacingInputSm3: au,
  spacingInputXs: ru,
  spacingTextLg: Zd,
  spacingTextMd: Yd,
  spacingTextSm: Jd,
  spacingTextXl: Qd,
  spacingTextXs: qd,
  spacingTextXxl: ou
}, Symbol.toStringTag, { value: "Module" })), Eg = "rgba(255,255,255,0.5)", jg = "rgba(34,34,34,0.5)", Ug = "rgba(18,18,18,0.8)", Kg = "rgba(225,225,225,0.8)", qg = "linear-gradient(180deg, rgba(0, 0, 0, 0.80) 0%, rgba(0, 0, 0, 0.00) 100%);", Jg = 218, Yg = 227, Zg = C, Qg = f, op = f * 1.5, rp = M, np = oo, ep = Yo, ap = Zo, ip = Sn, tp = C / 2.666, cp = C, lp = f, dp = M, up = oo, sp = C, gp = f, pp = M, Ip = oo, bp = Yo, Tp = Zo, Sp = C, xp = f, Bp = f * 1.375, mp = f * 1.5, hp = M, Cp = f * 2.5, vp = f * 2.8125, zp = C, fp = f, kp = M, Pp = oo, yp = C * 1.75, Lp = C * 2.25, Gp = C * 2.5, Hp = Jo, Vp = qo, _p = qo, Ap = Jo, Rp = J, $p = p, Mp = p, Dp = w, wp = Ho, Fp = Ho, Np = H, Op = io, Wp = jo, Xp = P, Ep = A, jp = Ho, Up = mo, Kp = mo, qp = F, Jp = y, Yp = ko, Zp = G, Qp = G, oI = A, rI = p, nI = H, eI = p, aI = Bo, iI = yo, tI = io, cI = J, lI = p, dI = P, uI = H, sI = H, gI = y, pI = J, II = H, bI = p, TI = G, SI = A, xI = P, BI = Bo, mI = nn, hI = io, CI = Lo, vI = p, zI = P, fI = G, kI = cn, PI = ln, yI = G, LI = J, GI = G, HI = yo, VI = p, _I = P, AI = Lo, RI = ao, $I = cr, MI = an, DI = J, wI = p, FI = Bo, NI = H, OI = A, WI = H, XI = tn, EI = P, jI = P, UI = p, KI = G, qI = p, JI = p, YI = Go, ZI = Go, QI = tr, ob = Ho, rb = w, nb = H, eb = Ko, ab = A, ib = P, tb = ao, cb = ao, lb = p, db = cr, ub = Ko, sb = m * 1.5, gb = ho, pb = m * 2.5, Ib = Y, bb = Z, Tb = Q, Sb = ho, xb = ho * 1.25, Bb = Y, mb = Z, hb = Q, Cb = j, vb = j, zb = Co, fb = In, kb = vo, Pb = bn, yb = Tn, Lb = m * 2.5, Gb = Y, Hb = Z, Vb = m * 13, _b = m * 17.75, Ab = Y, Rb = Z, $b = Q, Mb = j, Db = Co, wb = vo, Fb = m * 13, Nb = Q, Ob = j, Wb = Co, Xb = m * 11, Eb = m * 23.5, jb = m * 26.875, Ub = m * 30.25, Kb = m / 1.3333, qb = m / 2, Jb = Eo, Yb = xo, Zb = xo, Qb = Eo, oT = xo, rT = Zr, nT = un, eT = gn, aT = pn, iT = go, tT = Qr, cT = rn, lT = on, Bn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  borderRadiusLg: lT,
  borderRadiusMd: tT,
  borderRadiusSm: iT,
  borderRadiusXl: cT,
  borderUpload: rT,
  borderWidthCta: Yb,
  borderWidthHover: Qb,
  borderWidthSelected: Zb,
  borderWidthStandard: Jb,
  borderWidthStrikeout: oT,
  colourBackgroundActive: Np,
  colourBackgroundActiveInverse: qp,
  colourBackgroundActiveWeak: Up,
  colourBackgroundActiveWeakInverse: Kp,
  colourBackgroundCta: Rp,
  colourBackgroundCtaInverse: $p,
  colourBackgroundCtaInversePressed: Eg,
  colourBackgroundCtaPressed: jg,
  colourBackgroundCtaSecondary: jp,
  colourBackgroundCtaSuccess: Op,
  colourBackgroundDark: Wp,
  colourBackgroundDisabled: Xp,
  colourBackgroundHover: wp,
  colourBackgroundOverlay: Ug,
  colourBackgroundOverlayLight: Kg,
  colourBackgroundSelected: Fp,
  colourBackgroundStandard: Mp,
  colourBackgroundSubtle: Dp,
  colourBackgroundWeak: Ep,
  colourBorderActive: WI,
  colourBorderActiveInverse: JI,
  colourBorderBenchmark: YI,
  colourBorderBenchmarkInverse: ZI,
  colourBorderCta: DI,
  colourBorderCtaInverse: wI,
  colourBorderDisabled: XI,
  colourBorderError: FI,
  colourBorderSelected: NI,
  colourBorderStandard: OI,
  colourBorderStrikeout: jI,
  colourBorderStrikeoutInverse: UI,
  colourBorderStrong: KI,
  colourBorderWeak: EI,
  colourBorderWeakInverse: qI,
  colourDivider: MI,
  colourGradientNeutral: qg,
  colourIconActive: fI,
  colourIconAlert: BI,
  colourIconAlertInverse: mI,
  colourIconBottomNavigationActive: HI,
  colourIconBottomNavigationInactive: GI,
  colourIconCta: pI,
  colourIconCtaInverse: bI,
  colourIconCtaSecondary: II,
  colourIconDisabled: xI,
  colourIconInactive: zI,
  colourIconInverse: vI,
  colourIconLink: sI,
  colourIconLinkInverse: VI,
  colourIconLoader: yI,
  colourIconLocationPin: kI,
  colourIconLocationPinActive: PI,
  colourIconNeutral: gI,
  colourIconNotice: LI,
  colourIconPending: CI,
  colourIconRating: AI,
  colourIconSubtle: TI,
  colourIconSubtleInverse: _I,
  colourIconSuccess: hI,
  colourIconWeak: SI,
  colourNotificationAlert: QI,
  colourNotificationDefault: rb,
  colourNotificationPromo: ob,
  colourRibbonPrimary: tb,
  colourRibbonPrimary2: cb,
  colourRibbonPrimary3: lb,
  colourRibbonSecondary: db,
  colourRibbonSecondary2: ub,
  colourTagPrimary: RI,
  colourTagSecondary: $I,
  colourTextAlert: aI,
  colourTextCta: cI,
  colourTextCtaInverse: lI,
  colourTextCtaSecondary: uI,
  colourTextDisabled: oI,
  colourTextInverse: rI,
  colourTextLabel: Zp,
  colourTextLink: nI,
  colourTextLinkInverse: eI,
  colourTextNavigationActive: iI,
  colourTextNeutral: Jp,
  colourTextStrikethrough: Qp,
  colourTextSubtle: Yp,
  colourTextSubtleInverse: dI,
  colourTextSuccess: tI,
  colourToggleActiveStrong: nb,
  colourToggleActiveWeak: eb,
  colourToggleInactiveStrong: ab,
  colourToggleInactiveWeak: ib,
  opacityDisabled: _p,
  opacityHover: Hp,
  opacityOverlay: Ap,
  opacityPressed: Vp,
  shadowHigh: eT,
  shadowHighInverse: aT,
  shadowLow: nT,
  sizingBullet: Kb,
  sizingBulletSm: qb,
  sizingCirclePatternLg: Ub,
  sizingCirclePatternMd: jb,
  sizingCirclePatternSm: Eb,
  sizingCirclePatternXs: Xb,
  sizingFileInput: Jg,
  sizingFileInputLg: Yg,
  sizingIconGeneralLg: hb,
  sizingIconGeneralMd: mb,
  sizingIconGeneralSm: Bb,
  sizingIconGeneralXl: Cb,
  sizingIconGeneralXs: Sb,
  sizingIconGeneralXs2: xb,
  sizingIconSpotLg: kb,
  sizingIconSpotMd: fb,
  sizingIconSpotSm: zb,
  sizingIconSpotXl: Pb,
  sizingIconSpotXs: vb,
  sizingIconSpotXxl: yb,
  sizingIconUtilityLg: Tb,
  sizingIconUtilityMd: bb,
  sizingIconUtilitySm: Ib,
  sizingIconUtilityXs: gb,
  sizingIconUtilityXs2: pb,
  sizingIconUtilityXxs: sb,
  sizingImageLg: Db,
  sizingImageMd: Mb,
  sizingImageSm: $b,
  sizingImageXl: wb,
  sizingImageXs: Rb,
  sizingImageXxl: Fb,
  sizingImageXxs: Ab,
  sizingTagLg: Hb,
  sizingTagMd: Gb,
  sizingTagSm: Lb,
  sizingTextBoxMd: Wb,
  sizingTextBoxSm: Ob,
  sizingTextBoxXs: Nb,
  sizingVoucherMd: _b,
  sizingVoucherSm: Vb,
  spacingBulletMd: Gp,
  spacingBulletSm: Lp,
  spacingBulletXs: yp,
  spacingGapLg: np,
  spacingGapMd: rp,
  spacingGapSm: Qg,
  spacingGapSm2: op,
  spacingGapXl: ep,
  spacingGapXs: Zg,
  spacingGapXxl: ap,
  spacingGapXxxl: ip,
  spacingIconLg: up,
  spacingIconMd: dp,
  spacingIconSm: lp,
  spacingIconXs: cp,
  spacingIconXxs: tp,
  spacingImageLg: Pp,
  spacingImageMd: kp,
  spacingImageSm: fp,
  spacingImageXs: zp,
  spacingInputMd: hp,
  spacingInputMd2: Cp,
  spacingInputMd3: vp,
  spacingInputSm: xp,
  spacingInputSm2: Bp,
  spacingInputSm3: mp,
  spacingInputXs: Sp,
  spacingTextLg: Ip,
  spacingTextMd: pp,
  spacingTextSm: gp,
  spacingTextXl: bp,
  spacingTextXs: sp,
  spacingTextXxl: Tp
}, Symbol.toStringTag, { value: "Module" })), ro = ["48em", "62em", "75em", "100em", "1000em"], i = Qo(Bn), N = {
  marginTop: 0,
  marginBottom: 0,
  fontWeight: "unset",
  letterSpacing: 0,
  textRendering: "optimizeLegibility",
  "-webkit-font-smoothing": "antialiased"
}, O = {
  primary: `${$}, Adobe Heiti Std, Segoe UI, Trebuchet MS, sans-serif`,
  secondary: `${lr}, Georgia, Times New Roman, Times, serif`
}, dT = {
  xs: ro[0],
  // 768
  sm: ro[1],
  // 992
  md: ro[2],
  // 1200
  lg: ro[3],
  // 1600
  xl: ro[4]
  // 16000
}, mn = {
  breakpoints: ro,
  breakpointSizes: dT,
  space: [
    0,
    // space_0
    4,
    // space_1
    8,
    // space_2
    12,
    // space_3
    16,
    // space_4
    20,
    // space_5
    24,
    // space_6
    28,
    // space_7
    32,
    // space_8
    36,
    // space_9
    40
    // space_10
  ],
  borderRadius: {
    xs: "8px",
    sm: "10px",
    // Marked for removal
    md: "12px",
    // Marked for removal
    lg: "14px",
    // Marked for removal
    xl: "16px",
    xxl: "32px"
  },
  main: {
    colours: {
      white: "#FFFFFF",
      black: "#000000",
      /** Semantic colors used for signal severity */
      // Red for error, danger, wrong.
      errorRed: "#BC1430",
      // Green for success, safe, right
      successGreen: "#0CAA8F",
      // Divider color
      divider: "#D0D0D0",
      /** Colors Palette for DLS */
      primary: {
        l3: "#FCEAED",
        l2: "#FF7C92",
        l1: "#FF5D76",
        base: "#ED1A3D",
        d1: "#E71336",
        d2: "#CA112F",
        d3: "#BC1430",
        d4: "#6D0819"
      },
      secondary: {
        // purple
        l2: "#EFEDFD",
        l1: "#DEDAFA",
        base: "#9A8EF2",
        d1: "#5C50BB",
        d2: "#5457A0",
        d3: "#151560"
      },
      tertiary: {
        // neutral
        l6: "#F7F7F7",
        l5: "#E1E1E1",
        l4: "#A8A8A8",
        l3: "#757575",
        l2: "#565656",
        l1: "#3B3B3B",
        base: "#222222",
        d1: "#121212"
      }
    },
    shadows: {
      size1: "0 3px 8px 0 rgba(0 0 0 / 0.12)",
      size2: "0 6px 16px 0 rgba(0 0 0 / 0.10)"
    }
  }
}, uT = (o, e) => {
  var c;
  let t = null;
  return (c = e == null ? void 0 : e.main) != null && c.colours && (t = gd({}, o.main.colours, e.main.colours)), S(g({}, o), {
    main: S(g({}, o.main), {
      colours: t || o.main.colours
    })
  });
}, sT = (o = null) => {
  const e = Id(uT(mn, o)), t = {
    text: {
      bannerTitle: S(g({}, N), {
        fontSize: [
          z,
          z,
          36,
          Do,
          Do
        ],
        fontFamily: O.secondary,
        lineHeight: 1.3,
        fontWeight: 100,
        letterSpacing: 0.1
      }),
      pageTitle: S(g({}, N), {
        fontSize: [
          z,
          z,
          36,
          K,
          K
        ],
        fontFamily: O.secondary,
        lineHeight: 1.35,
        fontWeight: 300,
        letterSpacing: 0.1
      }),
      sectionTitle: S(g({}, N), {
        fontSize: [
          V,
          V,
          28,
          z,
          z
        ],
        fontFamily: O.primary,
        lineHeight: 1.35,
        letterSpacing: 0.1,
        fontWeight: 900
      }),
      sectionTitle02: S(g({}, N), {
        fontSize: [
          V,
          V,
          28,
          z,
          z
        ],
        fontFamily: O.primary,
        lineHeight: 1.35,
        letterSpacing: 0.1,
        fontWeight: 900
      }),
      header: S(g({}, N), {
        fontFamily: O.primary,
        fontWeight: W,
        fontSize: [
          L,
          L,
          L,
          V,
          V
        ],
        lineHeight: 1.35,
        letterSpacing: 0
      }),
      boldBody: S(g({}, N), {
        fontFamily: O.primary,
        fontWeight: W,
        fontSize: [
          l,
          l,
          h,
          L,
          L
        ],
        lineHeight: 1.75,
        letterSpacing: 0
      }),
      body: S(g({}, N), {
        fontFamily: O.primary,
        fontWeight: 350,
        fontSize: [
          l,
          l,
          h,
          L,
          L
        ],
        lineHeight: 1.75,
        letterSpacing: 0.1
      }),
      smallBody: S(g({}, N), {
        fontFamily: O.primary,
        fontWeight: 350,
        fontSize: [
          k,
          k,
          15,
          l,
          l
        ],
        lineHeight: 1.75,
        letterSpacing: 0.2
      }),
      boldSmallBody: S(g({}, N), {
        fontFamily: O.primary,
        fontWeight: W,
        fontSize: [
          k,
          k,
          15,
          l,
          l
        ],
        lineHeight: 1.75,
        letterSpacing: 0.2
      }),
      link: S(g({}, N), {
        fontFamily: O.primary,
        fontWeight: W,
        fontSize: [
          l,
          l,
          h,
          L,
          L
        ],
        lineHeight: 1.75,
        letterSpacing: 0.1
      }),
      smallBodyLink: S(g({}, N), {
        fontFamily: O.primary,
        fontWeight: uo,
        fontSize: [
          k,
          k,
          15,
          l,
          l
        ],
        lineHeight: D,
        letterSpacing: 0.1
      })
    },
    button: {
      minWidth: "128px",
      minHeight: "40px",
      border: "1px solid transparent",
      borderRadius: `${i.borderRadiusButton}px`,
      padding: `${i.spacingButtonPaddingVertical}px ${i.spacingButtonPaddingHorizontal}px`,
      background: i.colourButtonBackgroundPrimary,
      backgroundInverse: i.colourButtonBackgroundPrimaryInverse,
      mdMinHeight: "46px",
      secondary: {
        background: "transparent",
        border: `2px solid ${i.colourButtonSecondaryBorder}`,
        borderInverse: `2px solid ${p}`,
        color: i.colourButtonTextSecondary
      },
      mini: {
        minHeight: "32px",
        minWidth: "120px",
        padding: `${i.spacingButtonMiniPaddingVertical}px ${i.spacingButtonMiniPaddingHorizontal}px`,
        md: {
          minHeight: "32px",
          minWidth: "120px",
          padding: `${i.spacingButtonMiniPaddingVertical}px ${i.spacingButtonMiniPaddingHorizontal}px`
        }
      }
    },
    pagination: {
      fontSize: "0.875rem",
      marginTop: "16px",
      button: {
        fontFamily: e.ff_sec_regular,
        color: e.cl_ter_l2,
        backgroundColor: "transparent",
        hoverBg: e.cl_sec_l2,
        borderRadius: "16px",
        height: "32px",
        minWidth: "32px",
        margin: "0 3px",
        padding: "0 6px",
        selected: {
          color: e.cl_white,
          backgroundColor: e.cl_sec_d1
        },
        svg: {
          width: "16px",
          height: "16px"
        }
      }
    },
    listItem: {
      // Global Token
      borderRadius: 8,
      colorBg: e.cl_ter_l6,
      colorTextTitle: e.cl_ter_l1,
      colorTextSubtitle: e.cl_ter_l3,
      colorIcon: e.cl_sec_d1,
      fontSizeSM: 16,
      fontSizeMD: 20,
      fontSizeTitleSM: 16,
      fontSizeTitleMD: 20,
      fontSizeSubtitleSM: 14,
      fontSizeSubtitleMD: 16,
      lineHeight: "24px",
      lineHeightTitleMD: "30px",
      lineHeightSubtitleMD: "28px",
      sizeArrowIcon: "24px",
      sizeArrowIconXS: "16px",
      // Component Token
      controlMinWidth: 80,
      controlMinWidthTall: 104,
      controlMinWidthBorderless: 56,
      controlWidthTall: 104,
      controlMinHeight: 80,
      controlMinHeightTall: 104,
      controlMinHeightBorderless: 56,
      controlHeight: "100%",
      controlThumbnailWidth: 80,
      controlThumbnailBorderlessWidth: 56,
      controlAlignItems: "center",
      sizeIcon: 24,
      sizeImage: 48,
      sizeThumbnail: 104,
      sizeThumbnailIcon: 32
    },
    tag: {
      controlHeight: 20,
      colorBg: e.cl_pri_d2,
      colorText: e.cl_white,
      fontSize: [12, 12, 14, 14, 14],
      fontFamily: e.ff_sec_bold,
      letterSpacing: "0.002em",
      lineHeight: "20px",
      padding: "0 16px"
    },
    header: {
      desktopHeight: "116px",
      mobileHeight: "64px",
      borderTop: `4px solid ${e.cl_pri_base}`,
      boxShadow: e.sd_size_1,
      deskTopRHSMenuFontColor: e.cl_black,
      deskTopRHSMenuActiveFont: e.ff_sec_bold,
      deskTopRHSMenuInactiveFont: e.ff_sec_thin,
      deskTopLogoHeight: "48px",
      deskTopIconHeight: "40px",
      deskTopIconWidth: "40px",
      mobileIconHeight: "24px",
      mobileIconWidth: "24px",
      iconMenuFont: e.ff_sec_thin,
      iconMenuFontColor: e.cl_black,
      iconMenuActiveFontColor: e.cl_pri_base,
      desktopMenuFontSize: e.fs_md,
      desktopMenuActiveFontColor: e.cl_pri_base,
      desktopMenuInActiveFontColor: e.cl_black,
      desktopSubMenuFontSize: e.fs_md,
      mobileMenuFontSize: e.fs_sm,
      mobileMenuFontColor: e.cl_black,
      mobileMenuActiveFontColor: e.cl_pri_base,
      search: {
        searchInputFont: e.ff_sec_thin,
        searchInputFontColor: e.cl_black,
        searchInputPlaceholderFontColor: e.cl_ter_l4
      }
    },
    footer: {
      footerPage: {
        headingFont: e.ff_sec_bold,
        headingFontSize: e.fs_sm,
        headingFontColor: e.cl_black,
        itemFont: e.ff_sec_thin,
        itemFontSize: e.fs_sm,
        itemFontColor: e.cl_ter_l4
      },
      dividerBorder: `1px solid ${e.cl_ter_l4}`,
      linkFont: e.ff_sec_bold,
      linkFontColor: e.cl_ter_l4,
      linkFontSize: e.fs_xs,
      copyRightFont: e.ff_sec_thin,
      copyRightFontSize: e.fs_xs,
      copyRightFontColor: e.cl_ter_l4,
      footerTextFont: e.ff_sec_thin,
      footerTextFontSize: e.fs_xs,
      footerTextFontColor: e.cl_ter_l4,
      footerTextFontSpacing: "0.25px"
    },
    map: {
      mapTerrain: {
        waterGeometry: e.cl_ter_l5,
        landscapeGeometry: e.cl_ter_l6,
        roadHighwayGeometryFill: e.cl_white,
        roadHighwayGeometryStroke: e.cl_white,
        roadArterialGeometry: e.cl_white,
        roadLocalGeometry: e.cl_white,
        poiGeometry: e.cl_ter_l6,
        poiParkGeometry: e.cl_ter_l5,
        labelsTextStroke: e.cl_white,
        labelsTextFill: e.cl_ter_l4,
        transitGeometry: e.cl_ter_l6,
        administrativeGeometryFill: e.cl_ter_l6,
        administrativeGeometryStroke: e.cl_ter_l6
      },
      marker: {
        labelTextShadow: `1px 1px 1px ${e.cl_white}`,
        labelLineHeight: "16px",
        labelLetterSpacing: "0.2px",
        labelFontSize: e.fs_xs,
        labelColor: e.cl_black,
        labelFontFamily: e.ff_sec_regular
      }
    },
    table: {
      backgroundColor: {
        hover: e.cl_sec_l2,
        active: e.cl_sec_l2
      }
    },
    textLink: {
      color: e.cl_sec_d1,
      paddingRight: e.space_2
    },
    textInput: {
      padding: [
        "29px 16px 11px",
        "29px 16px 11px",
        "29px 16px 11px",
        "33px 16px 12px",
        "33px 16px 12px"
      ],
      topLabelText: "35px",
      caretColor: F,
      colourInputTextHint: i.colourInputTextHint,
      colourInputTextActive: i.colourInputTextActive,
      colourInputTextLabel: i.colourInputTextLabel,
      colourInputTextLabelActive: i.colourInputTextLabelActive,
      colourAdornmentText: i.colourInputTextLink,
      colourInputIconStandard: i.colourInputIconStandard
    },
    calendar: {
      arrowIconSize: 24,
      padding: "16px",
      paddingTopMobile: "24px",
      widthSelectedDay: "40px",
      heightSelectedDay: "40px",
      heightDayRow: "40px",
      colourCalendarIcon: i.colourCalendarIcon,
      colourNavigationIcon: i.colourCalendarIcon,
      colourCalendarTextDay: i.colourCalendarTextDay,
      colourCalendarBackgroundSelected: i.colourCalendarBackgroundSelected,
      colourCalendarBackgroundSelectedRange: i.colourCalendarBackgroundSelectedRange,
      shadowTopNavigation: i.shadowTopNavigation
    },
    textAreaInput: {
      fontWeightCharCount: no,
      colorCharCount: G,
      padding: [
        "34px 16px 16px",
        "34px 16px 16px",
        "34px 16px 16px",
        "37px 16px 16px",
        "37px 16px 16px"
      ]
    },
    formField: {
      backgroundColorError: p,
      colourInputBorderActive: i.colourInputBorderActive,
      colourInputBackground: i.colourInputBackground,
      colourInputBorderError: i.colourInputBorderError
    },
    formFieldHint: {
      marginTop: C
    },
    hintText: {
      fontSize: [
        u,
        u,
        u,
        k,
        k
      ],
      colourInputTextHint: i.colourInputTextHint,
      colourInputTextError: i.colourInputTextError
    },
    dropDownInput: {
      fontSize: [
        l,
        l,
        l,
        h,
        h
      ],
      fontWeight: uo,
      topIconWrapper: "23px",
      rightIconWrapper: M,
      color: i.colourInputTextActive,
      colourInputTextOptions: i.colourInputTextOptions,
      colourInputBorderStandard: i.colourInputBorderStandard,
      colourBackgroundStandard: i.colourInputBackground,
      colourInputIconStandard: i.colourInputIconStandard,
      colourInputBackgroundHover: i.colourInputBackgroundHover,
      colourInputBackgroundSelected: i.colourInputBackgroundSelected,
      spacingInputListOptionsPaddingHorizontal: i.spacingInputListOptionsPaddingHorizontal,
      spacingInputListOptionsPaddingVertical: i.spacingInputListOptionsPaddingVertical,
      imageSizes: [
        i.sizingInputImageFlag,
        i.sizingInputImageFlag,
        i.sizingInputImageFlag,
        i.sizingInputImageFlagLg,
        i.sizingInputImageFlagLg
      ],
      spacingInputImageFlagPaddingRight: i.spacingInputImageFlagPaddingRight,
      colourInputBackground: i.colourInputBackground,
      spacingInputOptionsPaddingVertical: i.spacingInputOptionsPaddingVertical
    },
    otpPinInput: {
      height: [64, 64, 72, 72, 72],
      maxWidth: "48px",
      loaderSize: "24px",
      colourInputBorderActive: i.colourInputBorderActive,
      colourInputBorderError: i.colourInputBorderError,
      colourInputBorderStandard: i.colourInputBorderStandard,
      colourInputBackgroundHaze: i.colourInputBackgroundHaze,
      colourInputBackground: i.colourInputBackground,
      colourInputTextLoading: i.colourInputTextLoading,
      colourInputTextActive: i.colourInputTextActive,
      spacingInputHorizontalGap: i.spacingInputHorizontalGap,
      colourInputIconLoader: i.colourInputIconLoader
    },
    numberList: {
      paddingTop: i.spacingNumberedListVerticalGap,
      paddingRight: i.spacingNumberedListHorizontalGap,
      colourText: i.colourNumberedListText,
      complexWidth: [36, 36, 36, 42, 42],
      simpleWidth: [24, 24, 24, 32, 32]
    },
    quantityInput: {
      height: 24,
      width: 24,
      color: y,
      spacingInputPaddingHorizontal: i.spacingInputPaddingHorizontal,
      spacingInputPaddingVertical: i.spacingInputPaddingVertical,
      paddingWrapper: 0,
      colourInputIconBackgroundActive: i.colourInputIconBackgroundActive,
      colourInputIconBackgroundDisabled: i.colourInputIconBackgroundDisabled,
      borderRadius: go,
      spacingInputTextNumberPaddingHorizontal: i.spacingInputTextNumberPaddingHorizontal
    },
    checkBoxInput: {
      fontFamily: $,
      fontSize: [
        l,
        l,
        l,
        h,
        h
      ],
      width: 24,
      height: 24,
      paddingLeft: 8,
      hoverXS: 8,
      hoverXL: 7,
      colourCheckboxInputBorderError: i.colourCheckboxInputBorderError,
      colourCheckboxInputBorderStandard: i.colourCheckboxInputBorderStandard,
      colourCheckboxInputBorderHover: i.colourCheckboxInputBorderHover,
      colourCheckboxInputBackgroundStandard: i.colourCheckboxInputBackgroundStandard,
      colourCheckboxInputBackgroundActive: i.colourCheckboxInputBackgroundActive
    },
    radioInput: {
      fontFamily: $,
      fontSize: [
        l,
        l,
        l,
        h,
        h
      ],
      width: 24,
      height: 24,
      padding: 8,
      widthInputRadio: 24,
      heightInputRadio: 24,
      marginLabel: "16px 0",
      borderRadioButtonEffect: 6,
      topRadioButtonEffect: 7,
      leftRadioButtonEffect: 7,
      colourRadioInputBackgroundStandard: i.colourRadioInputBackgroundStandard,
      colourRadioInputBackgroundActive: i.colourRadioInputBackgroundActive,
      colourRadioInputBorderError: i.colourRadioInputBorderError,
      colourRadioInputBorderStandard: i.colourRadioInputBorderStandard,
      colourRadioInputBorderHover: i.colourRadioInputBorderHover
    },
    fileInput: {
      fontFamily: $,
      fontSize: [
        l,
        l,
        l,
        l,
        l
      ],
      fontSizeLabelText: [
        u,
        u,
        u,
        u,
        u
      ],
      fontWeightLabelText: no,
      colourInputBorderStandard: i.colourInputBorderStandard,
      colourInputTextLink: i.colourInputTextLink,
      colourInputTextHint: i.colourInputTextHint,
      colourInputBorderActive: i.colourInputBorderActive,
      colourInputBorderError: i.colourInputBorderError
    },
    voucher: {
      titleColor: i.colourVoucherTextTitle,
      subtitleColor: i.colourVoucherTextSubtitle,
      subtitleExpiringColor: i.colourVoucherTextSubtitleExpiring,
      valueColor: i.colourVoucherTextPoints,
      backgroundColor: i.colourVoucherBackground,
      backgroundDisabled: i.colourVoucherBackgroundRedeemed,
      iconColor: i.colourVoucherIcon,
      paddingBodyVertical: i.spacingVoucherListViewTextVerticalGap,
      paddingBodyHorizontal: i.spacingVoucherGridViewTextHorizontalGap,
      heightLg: i.sizingVoucherHeightLg,
      height: i.sizingVoucherHeight,
      sizeImageLarge: i.sizingVoucherImageLg,
      sizeImage: i.sizingVoucherImage
    },
    bulletList: {
      paddingLeft: i.spacingBulletListPaddingLeft,
      horizontalGap: i.spacingBulletListHorizontalGap,
      sizingIcon: i.sizingBulletListIcon,
      colourBulletListIcon: i.colourBulletListIcon,
      colourStickyFooterBorderTop: i.colourStickyFooterBorderTop
    },
    accordion: {
      colourAccordionTextTitle: i.colourAccordionTextTitle,
      colourAccordionTextBody: i.colourAccordionTextBody,
      colourAccordionIcon: i.colourAccordionIcon,
      spacingAccordionTitlePaddingVertical: i.spacingAccordionTitlePaddingVertical,
      spacingAccordionHorizontalGap: i.spacingAccordionHorizontalGap,
      colourStickyFooterBorderTop: i.colourStickyFooterBorderTop
    },
    ribbon: {
      colourRibbonIconBackgroundPrimary: i.colourRibbonIconBackgroundPrimary,
      colourRibbonIconBackgroundSecondary: i.colourRibbonIconBackgroundSecondary,
      colourRibbonIconPrimary: i.colourRibbonIconPrimary,
      colourRibbonIconSecondary: i.colourRibbonIconSecondary,
      colourRibbonTextPrimary: i.colourRibbonTextPrimary,
      colourRibbonTextSecondary: i.colourRibbonTextSecondary,
      spacingRibbonHorizontalGap: i.spacingRibbonHorizontalGap,
      sizingRibbonIcon: i.sizingRibbonIcon,
      sizingRibbonIconBackground: i.sizingRibbonIconBackground,
      borderRadiusIconBackground: go
    },
    banner: {
      spacingBannerVerticalGap: i.spacingBannerVerticalGap,
      spacingBannerVerticalGapLg: i.spacingBannerVerticalGapLg,
      fill: i.colourBannerBackground,
      sizingBannerIconDesktop: vo,
      sizingBannerIconMobile: j,
      spacingBannerPaddingHorizontal: i.spacingBannerPaddingHorizontal,
      spacingBannerPaddingTop: i.spacingBannerPaddingTop
    },
    carousel: {
      borderRadiusCarouselFixedLg: i.borderRadiusCarouselFixedLg,
      colourCarouselArrowBackground: i.colourCarouselArrowBackground,
      colourCarouselArrowIcon: i.colourCarouselArrowIcon,
      sizingCarouselIcon: i.sizingCarouselIcon,
      sizingCarouselIconBackground: i.sizingCarouselIconBackground,
      spacingCarouselIndicatorPaddingTopLg: i.spacingCarouselIndicatorPaddingTopLg,
      spacingCarouselIndicatorHorizontalGap: i.spacingCarouselIndicatorHorizontalGap,
      colourCarouselIndicatorActive: i.colourCarouselIndicatorActive,
      colourCarouselIndicatorInactive: i.colourCarouselIndicatorInactive,
      colourCarouselOverlay: i.colourCarouselOverlay,
      colourTagBackgroundPrimary: i.colourTagBackgroundPrimary
    },
    notification: {
      paddingVertical: i.spacingNotificationPaddingVertical,
      paddingHorizontal: i.spacingNotificationPaddingHorizontal,
      paddingVerticalLg: i.spacingNotificationPaddingVerticalLg,
      paddingHorizontalLg: i.spacingNotificationPaddingHorizontalLg,
      colourNotificationBackgroundAlert: i.colourNotificationBackgroundAlert,
      colourNotificationBackgroundInfo: i.colourNotificationBackgroundInfo,
      colourNotificationBackgroundPromo: i.colourNotificationBackgroundPromo,
      borderRadius: i.borderRadiusNotification,
      sizingNotificationIcon: i.sizingNotificationIcon,
      spacingNotificationHorizontalGap: i.spacingNotificationHorizontalGap,
      spacingNotificationVerticalGap: i.spacingNotificationVerticalGap
    },
    selector: {
      paddingTop: i.spacingSelectorPaddingVertical,
      paddingRight: i.spacingSelectorPaddingHorizontal,
      paddingBottom: i.spacingSelectorPaddingVertical,
      paddingLeft: i.spacingSelectorPaddingHorizontal,
      paddingVertical: i.spacingSelectorPaddingVertical,
      paddingHorizontal: i.spacingSelectorPaddingHorizontal,
      spacingSelectorVariant6PaddingHorizontal: i.spacingSelectorVariant6PaddingHorizontal,
      colourSelectorBackground: i.colourSelectorBackground,
      colourSelectorBorderActive: i.colourSelectorBorderActive,
      colourSelectorBorderStandard: i.colourSelectorBorderStandard,
      colourSelectorTextTitle: i.colourSelectorTextTitle,
      colourSelectorTextSubtitle: i.colourSelectorTextSubtitle,
      borderRadius: i.borderRadiusSelector,
      borderWidthSelectorActive: i.borderWidthSelectorActive,
      borderWidthSelectorStandard: i.borderWidthSelectorStandard,
      opacitySelectorTextDisabled: i.opacitySelectorTextDisabled,
      opacitySelectorImageDisabled: i.opacitySelectorImageDisabled,
      colourSelectorBorderDisabled: i.colourSelectorBorderDisabled,
      colourSelectorTextDisabled: i.colourSelectorTextDisabled,
      sizingSelectorThumbnail: i.sizingSelectorThumbnail,
      colourSelectorColourIndicatorBorderOuter: i.colourSelectorColourIndicatorBorderOuter,
      colourSelectorColourIndicatorBorderInner: i.colourSelectorColourIndicatorBorderInner,
      colourSelectorColourIndicatorStrikeout: i.colourSelectorColourIndicatorStrikeout,
      colourSelectorColourIndicatorStrikeoutInverse: i.colourSelectorColourIndicatorStrikeoutInverse,
      borderWidthSelectorStrikeout: i.borderWidthSelectorStrikeout
    },
    modal: {
      colourModalBackground: i.colourModalBackground,
      colourModalBackgroundHaze: w,
      borderRadiusModal: i.borderRadiusModal,
      padding: 0,
      colourScrollbarNeutral: p,
      colourScrollbar: A,
      colourModalIcon: i.colourModalIcon,
      columMd: 6,
      columnMdWide: 8,
      colourStickyFooterBorderTop: i.colourStickyFooterBorderTop
    },
    card: {
      iconCounterBackground: i.colourCardIconListThumbnailBackground,
      iconCounterBorderColor: i.colourCardIconListThumbnailBorder,
      iconCounterBorderRadius: i.borderRadiusCardSm,
      iconCounterTextColor: i.colourCardTextSubtitle,
      spacingCardFeatureVerticalGap: i.spacingCardBodyVerticalGap,
      shadowCardLow: i.shadowCardLow,
      shadowCardHigh: i.shadowCardHigh,
      borderRadiusCardSm: i.borderRadiusCardSm,
      borderRadiusCardMd: i.borderRadiusCardMd,
      borderRadiusCardLg: i.borderRadiusCardLg,
      paddingSm: `${i.spacingCardPaddingHorizontal}px ${i.spacingCardPaddingVertical}px`,
      paddingMd: `${i.spacingCardPaddingHorizontalLg}px ${i.spacingCardPaddingVerticalLg}px`,
      paddingLg: `${i.spacingCardPaddingHorizontalXl}px ${i.spacingCardPaddingVerticalXl}px`,
      subtitleColor: i.colourCardTextSubtitle,
      cardTextPriceColor: i.colourCardTextPrice,
      cardTextTitleColor: i.colourCardTextTitle,
      cardTextTitleColorStrikethrough: i.colourCardTextPriceStrikethrough,
      spacingCardFooterVerticalGap: i.spacingCardFooterVerticalGap,
      spacingCardBodyVerticalGap: i.spacingCardBodyVerticalGap
    },
    toast: {
      iconColorSuccess: i.colourToastIconSuccess,
      iconColorAlert: i.colourToastIconAlert,
      iconColorPending: i.colourToastIconPending,
      paddingTop: i.spacingToastPaddingVertical,
      paddingRight: i.spacingToastPaddingHorizontal,
      paddingBottom: i.spacingToastPaddingVertical,
      paddingLeft: i.spacingToastPaddingHorizontal,
      paddingTopLg: i.spacingToastPaddingVerticalLg,
      paddingRightLg: i.spacingToastPaddingHorizontalLg,
      paddingBottomLg: i.spacingToastPaddingVerticalLg,
      paddingLeftLg: i.spacingToastPaddingHorizontalLg,
      backgroundColor: i.colourToastBackground,
      borderRadiusTopLeft: 8,
      //TODO check with Dilys
      borderRadiusTopRight: 8,
      //TODO check with Dilys
      borderRadiusBottomRight: 8,
      //TODO check with Dilys
      borderRadiusBottomLeft: 8,
      //TODO check with Dilys
      colourText: i.colourToastTextInverse,
      colourTextLink: i.colourToastTextLinkInverse,
      spacing: i.spacingToastHorizontalGap
    },
    circlePattern: {
      color: i.colourCirclePatternTextHeader,
      textPaddingTop: i.spacingCirclePatternVariant1TextPaddingTop,
      paddingRight: 24,
      //"spacing.gap.lg"; check with Dilys
      paddingLeft: 24,
      //"spacing.gap.lg"; check with Dilys
      paddingVertical: i.spacingCirclePatternVariant1VerticalGap,
      thumbSizingVariant1Lg: i.sizingCirclePatternVariant1Lg,
      thumbSizingVariant1: i.sizingCirclePatternVariant1,
      thumbSizingVariant2Lg: i.sizingCirclePatternVariant2Lg,
      thumbSizingVariant2: i.sizingCirclePatternVariant2,
      paddingLeftVariant2: i.spacingCirclePatternVariant2TextPaddingLeft
    },
    stepper: {
      textLabelColor: i.colourStepperTextLabel,
      sizingInnerLg: i.sizingStepperInnerLg,
      sizingInner: i.sizingStepperInner,
      sizingOuter: i.sizingStepperOuter,
      sizingOuterLg: i.sizingStepperOuterLg,
      borderColorActive: i.colourStepperBorderActive,
      textActiveColor: i.colourStepperTextActive,
      textInactiveColor: i.colourStepperTextInactive,
      successBackground: i.colourStepperBackgroundSuccess,
      inactiveBackground: i.colourStepperBackgroundInactive,
      connectorInactiveBorderColor: i.colourStepperConnectorInactive,
      connectorActiveBorderColor: i.colourStepperConnectorSuccess
    },
    tab: {
      borderActive: i.colourTabsBorderActive,
      borderInActive: i.colourTabsBorderInactive,
      paddingBottom: i.spacingTabsVerticalGap,
      titleTextActiveColor: i.colourTabsTextTitle,
      titleTextInactiveColor: i.colourTabsTextTitleInactive,
      subtitleTextActiveColor: i.colourTabsTextSubtitle,
      subtitleTextInActiveColor: i.colourTabsTextSubtitleInactive,
      iconColorActive: i.colourTabsIconActive,
      iconColorInActive: i.colourTabsIconInactive,
      iconSize: i.sizingTabsIcon,
      borderWidthTabsActive: i.borderWidthTabsActive,
      // Todo: replace with tokens in DLS-2018
      bottomBorderColor: e.cl_ter_l5,
      tabBarDividerPositionBottom: 0,
      tabItemContainerPadding: `${e.space_4}px ${e.space_6}px ${e.space_2}px`,
      selectedTabTitleColor: e.cl_sec_d1,
      tabTitleColor: e.cl_ter_base,
      tabItemContainerHoverBg: hd(e.cl_sec_l1, 0.8),
      tabItemContainerBg: e.cl_white,
      tabItemIndicatorBgColor: e.cl_sec_d1,
      tabBarDividerBgColor: e.cl_ter_l5
    }
  };
  return g(g({}, e), md(t, o));
}, gT = sT(), a = Qo(xn), pT = {
  space_0: 0,
  space_1: 4,
  space_2: 8,
  space_3: 12,
  space_4: 16,
  space_5: 20,
  space_6: 24,
  space_7: 28,
  space_8: 32,
  space_9: 36,
  space_10: 40,
  brk_xs: "48em",
  brk_sm: "62em",
  brk_md: "75em",
  brk_lg: "100em",
  brk_xl: "1000em",
  rad_xs: "8px",
  rad_sm: "10px",
  rad_md: "12px",
  rad_lg: "14px",
  rad_xl: "16px",
  rad_xxl: "32px",
  cl_white: "#FFFFFF",
  cl_black: "#000000",
  cl_successGreen: "#0CAA8F",
  cl_errorRed: "#BC1430",
  cl_divider: "#D0D0D0",
  cl_pri_l3: "#FCEAED",
  cl_pri_l2: "#FF7C92",
  cl_pri_l1: "#FF5D76",
  cl_pri_base: "#ED1A3D",
  cl_pri_d1: "#E71336",
  cl_pri_d2: "#CA112F",
  cl_pri_d3: "#BC1430",
  cl_pri_d4: "#6D0819",
  cl_sec_l2: "#EFEDFD",
  cl_sec_l1: "#DEDAFA",
  cl_sec_base: "#9A8EF2",
  cl_sec_d1: "#5C50BB",
  cl_sec_d2: "#5457A0",
  cl_sec_d3: "#151560",
  cl_ter_l6: "#F7F7F7",
  cl_ter_l5: "#E1E1E1",
  cl_ter_l4: "#A8A8A8",
  cl_ter_l3: "#757575",
  cl_ter_l2: "#565656",
  cl_ter_l1: "#3B3B3B",
  cl_ter_base: "#222222",
  cl_ter_d1: "#121212",
  fs_xs: "12px",
  fs_sm: "14px",
  fs_md: "16px",
  fs_lg: "18px",
  fs_xl: "20px",
  fs_xxl: "22px",
  sd_size_1: "0 3px 8px 0 rgba(0 0 0 / 0.12)",
  sd_size_2: "0 6px 16px 0 rgba(0 0 0 / 0.10)"
}, IT = S(g({}, pT), {
  text: yd,
  button: {
    minWidth: "128px",
    minHeight: "40px",
    border: "1px solid transparent",
    borderRadius: `${a.borderRadiusButton}px`,
    padding: `${a.spacingButtonPaddingVertical}px ${a.spacingButtonPaddingHorizontal}px`,
    background: a.colourButtonBackgroundPrimary,
    backgroundInverse: a.colourButtonBackgroundPrimaryInverse,
    mdMinHeight: "46px",
    secondary: {
      background: "transparent",
      border: `2px solid ${a.colourButtonSecondaryBorder}`,
      borderInverse: `2px solid ${p}`,
      color: a.colourButtonTextSecondary
    },
    mini: {
      minHeight: "32px",
      minWidth: "120px",
      padding: `${a.spacingButtonMiniPaddingVertical}px ${a.spacingButtonMiniPaddingHorizontal}px`,
      md: {
        minHeight: "32px",
        minWidth: "120px",
        padding: `${a.spacingButtonMiniPaddingVertical}px ${a.spacingButtonMiniPaddingHorizontal}px`
      }
    }
  },
  formField: {
    backgroundColorError: p,
    colourInputBorderActive: a.colourInputBorderActive,
    colourInputBackground: a.colourInputBackground,
    colourInputBorderError: a.colourInputBorderError
  },
  formFieldHint: {
    marginTop: C
  },
  textInput: {
    padding: [
      "29px 16px 11px",
      "29px 16px 11px",
      "29px 16px 11px",
      "33px 16px 12px",
      "33px 16px 12px"
    ],
    topLabelText: "35px",
    caretColor: F,
    colourInputTextHint: a.colourInputTextHint,
    colourInputTextActive: a.colourInputTextActive,
    colourInputTextLabel: a.colourInputTextLabel,
    colourInputTextLabelActive: a.colourInputTextLabelActive,
    colourAdornmentText: a.colourInputTextLink,
    colourInputIconStandard: a.colourInputIconStandard
  },
  textAreaInput: {
    fontWeightCharCount: no,
    colorCharCount: G,
    padding: [
      "34px 16px 16px",
      "34px 16px 16px",
      "34px 16px 16px",
      "37px 16px 16px",
      "37px 16px 16px"
    ]
  },
  hintText: {
    fontSize: [
      u,
      u,
      u,
      k,
      k
    ],
    colourInputTextHint: a.colourInputTextHint,
    colourInputTextError: a.colourInputTextError
  },
  dropDownInput: {
    fontSize: [
      l,
      l,
      l,
      h,
      h
    ],
    fontWeight: uo,
    topIconWrapper: "23px",
    rightIconWrapper: M,
    color: a.colourInputTextActive,
    colourInputTextOptions: a.colourInputTextOptions,
    colourInputBorderStandard: a.colourInputBorderStandard,
    colourBackgroundStandard: a.colourInputBackground,
    colourInputIconStandard: a.colourInputIconStandard,
    colourInputBackgroundHover: a.colourInputBackgroundHover,
    colourInputBackgroundSelected: a.colourInputBackgroundSelected,
    spacingInputListOptionsPaddingHorizontal: a.spacingInputListOptionsPaddingHorizontal,
    spacingInputListOptionsPaddingVertical: a.spacingInputListOptionsPaddingVertical,
    imageSizes: [
      a.sizingInputImageFlag,
      a.sizingInputImageFlag,
      a.sizingInputImageFlag,
      a.sizingInputImageFlagLg,
      a.sizingInputImageFlagLg
    ],
    spacingInputImageFlagPaddingRight: a.spacingInputImageFlagPaddingRight,
    colourInputBackground: a.colourInputBackground,
    spacingInputOptionsPaddingVertical: a.spacingInputOptionsPaddingVertical
  },
  checkBoxInput: {
    fontFamily: $,
    fontSize: [
      l,
      l,
      l,
      h,
      h
    ],
    width: 24,
    height: 24,
    paddingLeft: 8,
    hoverXS: 8,
    hoverXL: 7,
    colourCheckboxInputBorderError: a.colourCheckboxInputBorderError,
    colourCheckboxInputBorderStandard: a.colourCheckboxInputBorderStandard,
    colourCheckboxInputBorderHover: a.colourCheckboxInputBorderHover,
    colourCheckboxInputBackgroundStandard: a.colourCheckboxInputBackgroundStandard,
    colourCheckboxInputBackgroundActive: a.colourCheckboxInputBackgroundActive
  },
  radioInput: {
    fontFamily: $,
    fontSize: [
      l,
      l,
      l,
      h,
      h
    ],
    width: 24,
    height: 24,
    padding: 8,
    widthInputRadio: 24,
    heightInputRadio: 24,
    marginLabel: "16px 0",
    borderRadioButtonEffect: 6,
    topRadioButtonEffect: 7,
    leftRadioButtonEffect: 7,
    colourRadioInputBackgroundStandard: a.colourRadioInputBackgroundStandard,
    colourRadioInputBackgroundActive: a.colourRadioInputBackgroundActive,
    colourRadioInputBorderError: a.colourRadioInputBorderError,
    colourRadioInputBorderStandard: a.colourRadioInputBorderStandard,
    colourRadioInputBorderHover: a.colourRadioInputBorderHover
  },
  quantityInput: {
    height: 24,
    width: 24,
    color: y,
    spacingInputPaddingHorizontal: a.spacingInputPaddingHorizontal,
    spacingInputPaddingVertical: a.spacingInputPaddingVertical,
    paddingWrapper: 0,
    colourInputIconBackgroundActive: a.colourInputIconBackgroundActive,
    colourInputIconBackgroundDisabled: a.colourInputIconBackgroundDisabled,
    borderRadius: go
  },
  fileInput: {
    fontFamily: $,
    fontSize: [
      l,
      l,
      l,
      l,
      l
    ],
    fontSizeLabelText: [
      u,
      u,
      u,
      u,
      u
    ],
    fontWeightLabelText: no,
    colourInputBorderStandard: a.colourInputBorderStandard,
    colourInputTextLink: a.colourInputTextLink,
    colourInputTextHint: a.colourInputTextHint,
    colourInputBorderActive: a.colourInputBorderActive,
    colourInputBorderError: a.colourInputBorderError
  },
  iconButton: {
    fontFamily: $,
    fontSize: [
      u,
      u,
      u,
      u,
      u
    ],
    fontWeight: W
  },
  calendar: {
    arrowIconSize: 24,
    padding: "16px",
    paddingTopMobile: "24px",
    widthSelectedDay: "40px",
    heightSelectedDay: "40px",
    heightDayRow: "40px",
    colourCalendarIcon: a.colourCalendarIcon,
    colourNavigationIcon: a.colourCalendarIcon,
    colourCalendarTextDay: a.colourCalendarTextDay,
    colourCalendarBackgroundSelected: a.colourCalendarBackgroundSelected,
    colourCalendarBackgroundSelectedRange: a.colourCalendarBackgroundSelectedRange,
    shadowTopNavigation: a.shadowTopNavigation
  },
  otpPinInput: {
    height: [64, 64, 72, 72, 72],
    maxWidth: "48px",
    loaderSize: "24px",
    colourInputBorderActive: a.colourInputBorderActive,
    colourInputBorderError: a.colourInputBorderError,
    colourInputBorderStandard: a.colourInputBorderStandard,
    colourInputBackgroundHaze: a.colourInputBackgroundHaze,
    colourInputBackground: a.colourInputBackground,
    colourInputTextLoading: a.colourInputTextLoading,
    colourInputTextActive: a.colourInputTextActive,
    spacingInputHorizontalGap: a.spacingInputHorizontalGap,
    colourInputIconLoader: a.colourInputIconLoader
  },
  link: {
    color: F,
    fontSize: [
      l,
      l,
      l,
      h,
      h
    ]
  },
  listItem: {
    toggleBg: P,
    toggleSwitchHover: P,
    colorIcon: y,
    colorSubtitleIcon: ko,
    iconColorOn: jo,
    iconColorOff: A,
    colorTextTitle: y,
    colorTextSubtitle: ko,
    colorBg: w,
    sizeArrowIcon: "24px",
    sizeArrowIconXS: "16px",
    // Component Token
    controlMinWidth: 80,
    controlMinWidthTall: 104,
    controlMinWidthBorderless: 56,
    controlWidthTall: 104,
    controlMinHeight: 80,
    controlMinHeightTall: 104,
    controlMinHeightBorderless: 56,
    controlHeight: "100%",
    controlThumbnailWidth: 80,
    controlThumbnailBorderlessWidth: 56,
    controlAlignItems: "center",
    sizeIcon: 24,
    sizeImage: 48,
    sizeThumbnail: 104,
    sizeThumbnailIcon: 32,
    borderRadius: a.borderRadiusListItem
  },
  numberList: {
    paddingTop: a.spacingNumberedListVerticalGap,
    paddingRight: a.spacingNumberedListHorizontalGap,
    colourText: a.colourNumberedListText,
    complexWidth: [36, 36, 36, 42, 42],
    simpleWidth: [24, 24, 24, 32, 32]
  },
  textLink: {
    colourTextLinkText: a.colourTextLinkText,
    paddingRight: a.spacingTextLinkHorizontalGap
  },
  voucher: {
    titleColor: a.colourVoucherTextTitle,
    subtitleColor: a.colourVoucherTextSubtitle,
    subtitleExpiringColor: a.colourVoucherTextSubtitleExpiring,
    valueColor: a.colourVoucherTextPoints,
    backgroundColor: a.colourVoucherBackground,
    backgroundDisabled: a.colourVoucherBackgroundRedeemed,
    iconColor: a.colourVoucherIcon,
    paddingBodyVertical: a.spacingVoucherListViewTextVerticalGap,
    paddingBodyHorizontal: a.spacingVoucherGridViewTextHorizontalGap,
    heightLg: a.sizingVoucherHeightLg,
    height: a.sizingVoucherHeight,
    sizeImageLarge: a.sizingVoucherImageLg,
    sizeImage: a.sizingVoucherImage
  },
  bulletList: {
    paddingLeft: a.spacingBulletListPaddingLeft,
    horizontalGap: a.spacingBulletListHorizontalGap,
    sizingIcon: a.sizingBulletListIcon,
    colourBulletListIcon: a.colourBulletListIcon,
    colourStickyFooterBorderTop: a.colourStickyFooterBorderTop
  },
  accordion: {
    colourAccordionTextTitle: a.colourAccordionTextTitle,
    colourAccordionTextBody: a.colourAccordionTextBody,
    colourAccordionIcon: a.colourAccordionIcon,
    spacingAccordionTitlePaddingVertical: a.spacingAccordionTitlePaddingVertical,
    spacingAccordionHorizontalGap: a.spacingAccordionHorizontalGap,
    colourStickyFooterBorderTop: a.colourStickyFooterBorderTop
  },
  ribbon: {
    colourRibbonIconBackgroundPrimary: a.colourRibbonIconBackgroundPrimary,
    colourRibbonIconBackgroundSecondary: a.colourRibbonIconBackgroundSecondary,
    colourRibbonIconPrimary: a.colourRibbonIconPrimary,
    colourRibbonIconSecondary: a.colourRibbonIconSecondary,
    colourRibbonTextPrimary: a.colourRibbonTextPrimary,
    colourRibbonTextSecondary: a.colourRibbonTextSecondary,
    spacingRibbonHorizontalGap: a.spacingRibbonHorizontalGap,
    sizingRibbonIcon: a.sizingRibbonIcon,
    sizingRibbonIconBackground: a.sizingRibbonIconBackground,
    borderRadiusIconBackground: go
  },
  banner: {
    spacingBannerVerticalGap: a.spacingBannerVerticalGap,
    spacingBannerVerticalGapLg: a.spacingBannerVerticalGapLg,
    fill: a.colourBannerBackground,
    sizingBannerIconDesktop: vo,
    sizingBannerIconMobile: j,
    spacingBannerPaddingHorizontal: a.spacingBannerPaddingHorizontal,
    spacingBannerPaddingTop: a.spacingBannerPaddingTop
  },
  carousel: {
    borderRadiusCarouselFixedLg: a.borderRadiusCarouselFixedLg,
    colourCarouselArrowBackground: a.colourCarouselArrowBackground,
    colourCarouselArrowIcon: a.colourCarouselArrowIcon,
    sizingCarouselIcon: a.sizingCarouselIcon,
    sizingCarouselIconBackground: a.sizingCarouselIconBackground,
    spacingCarouselIndicatorPaddingTopLg: a.spacingCarouselIndicatorPaddingTopLg,
    spacingCarouselIndicatorHorizontalGap: a.spacingCarouselIndicatorHorizontalGap,
    colourCarouselIndicatorActive: a.colourCarouselIndicatorActive,
    colourCarouselIndicatorInactive: a.colourCarouselIndicatorInactive,
    colourCarouselOverlay: a.colourCarouselOverlay,
    colourTagBackgroundPrimary: a.colourTagBackgroundPrimary
  },
  notification: {
    paddingVertical: a.spacingNotificationPaddingVertical,
    paddingHorizontal: a.spacingNotificationPaddingHorizontal,
    paddingVerticalLg: a.spacingNotificationPaddingVerticalLg,
    paddingHorizontalLg: a.spacingNotificationPaddingHorizontalLg,
    colourNotificationBackgroundAlert: a.colourNotificationBackgroundAlert,
    colourNotificationBackgroundInfo: a.colourNotificationBackgroundInfo,
    colourNotificationBackgroundPromo: a.colourNotificationBackgroundPromo,
    borderRadius: a.borderRadiusNotification,
    sizingNotificationIcon: a.sizingNotificationIcon,
    spacingNotificationHorizontalGap: a.spacingNotificationHorizontalGap,
    spacingNotificationVerticalGap: a.spacingNotificationVerticalGap
  },
  selector: {
    paddingTop: a.spacingSelectorPaddingVertical,
    paddingRight: a.spacingSelectorPaddingHorizontal,
    paddingBottom: a.spacingSelectorPaddingVertical,
    paddingLeft: a.spacingSelectorPaddingHorizontal,
    paddingVertical: a.spacingSelectorPaddingVertical,
    paddingHorizontal: a.spacingSelectorPaddingHorizontal,
    spacingSelectorVariant6PaddingHorizontal: a.spacingSelectorVariant6PaddingHorizontal,
    colourSelectorBackground: a.colourSelectorBackground,
    colourSelectorBorderActive: a.colourSelectorBorderActive,
    colourSelectorBorderStandard: a.colourSelectorBorderStandard,
    colourSelectorTextTitle: a.colourSelectorTextTitle,
    colourSelectorTextSubtitle: a.colourSelectorTextSubtitle,
    borderRadius: a.borderRadiusSelector,
    borderWidthSelectorActive: a.borderWidthSelectorActive,
    borderWidthSelectorStandard: a.borderWidthSelectorStandard,
    opacitySelectorTextDisabled: a.opacitySelectorTextDisabled,
    opacitySelectorImageDisabled: a.opacitySelectorImageDisabled,
    colourSelectorBorderDisabled: a.colourSelectorBorderDisabled,
    colourSelectorTextDisabled: a.colourSelectorTextDisabled,
    sizingSelectorThumbnail: a.sizingSelectorThumbnail,
    colourSelectorColourIndicatorBorderOuter: a.colourSelectorColourIndicatorBorderOuter,
    colourSelectorColourIndicatorBorderInner: a.colourSelectorColourIndicatorBorderInner,
    colourSelectorColourIndicatorStrikeout: a.colourSelectorColourIndicatorStrikeout,
    colourSelectorColourIndicatorStrikeoutInverse: a.colourSelectorColourIndicatorStrikeoutInverse,
    borderWidthSelectorStrikeout: a.borderWidthSelectorStrikeout
  },
  modal: {
    colourModalBackground: a.colourModalBackground,
    colourModalBackgroundHaze: w,
    borderRadiusModal: a.borderRadiusModal,
    padding: 0,
    colourScrollbarNeutral: p,
    colourScrollbar: A,
    colourModalIcon: a.colourModalIcon,
    columMd: 6,
    columnMdWide: 8,
    colourStickyFooterBorderTop: a.colourStickyFooterBorderTop
  },
  card: {
    iconCounterBackground: a.colourCardIconListThumbnailBackground,
    iconCounterBorderColor: a.colourCardIconListThumbnailBorder,
    iconCounterBorderRadius: a.borderRadiusCardSm,
    iconCounterTextColor: a.colourCardTextSubtitle,
    spacingCardFeatureVerticalGap: a.spacingCardBodyVerticalGap,
    shadowCardLow: a.shadowCardLow,
    shadowCardHigh: a.shadowCardHigh,
    borderRadiusCardSm: a.borderRadiusCardSm,
    borderRadiusCardMd: a.borderRadiusCardMd,
    borderRadiusCardLg: a.borderRadiusCardLg,
    paddingSm: `${a.spacingCardPaddingHorizontal}px ${a.spacingCardPaddingVertical}px`,
    paddingMd: `${a.spacingCardPaddingHorizontalLg}px ${a.spacingCardPaddingVerticalLg}px`,
    paddingLg: `${a.spacingCardPaddingHorizontalXl}px ${a.spacingCardPaddingVerticalXl}px`,
    subtitleColor: a.colourCardTextSubtitle,
    cardTextPriceColor: a.colourCardTextPrice,
    cardTextTitleColor: a.colourCardTextTitle,
    cardTextTitleColorStrikethrough: a.colourCardTextPriceStrikethrough,
    spacingCardFooterVerticalGap: a.spacingCardFooterVerticalGap,
    spacingCardBodyVerticalGap: a.spacingCardBodyVerticalGap
  },
  toast: {
    iconColorSuccess: a.colourToastIconSuccess,
    iconColorAlert: a.colourToastIconAlert,
    iconColorPending: a.colourToastIconPending,
    paddingTop: a.spacingToastPaddingVertical,
    paddingRight: a.spacingToastPaddingHorizontal,
    paddingBottom: a.spacingToastPaddingVertical,
    paddingLeft: a.spacingToastPaddingHorizontal,
    paddingTopLg: a.spacingToastPaddingVerticalLg,
    paddingRightLg: a.spacingToastPaddingHorizontalLg,
    paddingBottomLg: a.spacingToastPaddingVerticalLg,
    paddingLeftLg: a.spacingToastPaddingHorizontalLg,
    backgroundColor: a.colourToastBackground,
    borderRadiusTopLeft: 8,
    //TODO check with Dilys
    borderRadiusTopRight: 8,
    //TODO check with Dilys
    borderRadiusBottomRight: 8,
    //TODO check with Dilys
    borderRadiusBottomLeft: 8,
    //TODO check with Dilys
    colourText: a.colourToastTextInverse,
    colourTextLink: a.colourToastTextLinkInverse,
    spacing: a.spacingToastHorizontalGap
  },
  circlePattern: {
    color: a.colourCirclePatternTextHeader,
    textPaddingTop: a.spacingCirclePatternVariant1TextPaddingTop,
    paddingRight: 24,
    //"spacing.gap.lg"; check with Dilys
    paddingLeft: 24,
    //"spacing.gap.lg"; check with Dilys
    paddingVertical: a.spacingCirclePatternVariant1VerticalGap,
    thumbSizingVariant1Lg: a.sizingCirclePatternVariant1Lg,
    thumbSizingVariant1: a.sizingCirclePatternVariant1,
    thumbSizingVariant2Lg: a.sizingCirclePatternVariant2Lg,
    thumbSizingVariant2: a.sizingCirclePatternVariant2,
    paddingLeftVariant2: a.spacingCirclePatternVariant2TextPaddingLeft
  },
  stepper: {
    textLabelColor: a.colourStepperTextLabel,
    sizingInnerLg: a.sizingStepperInnerLg,
    sizingInner: a.sizingStepperInner,
    sizingOuter: a.sizingStepperOuter,
    sizingOuterLg: a.sizingStepperOuterLg,
    borderColorActive: a.colourStepperBorderActive,
    textActiveColor: a.colourStepperTextActive,
    textInactiveColor: a.colourStepperTextInactive,
    successBackground: a.colourStepperBackgroundSuccess,
    inactiveBackground: a.colourStepperBackgroundInactive,
    connectorInactiveBorderColor: a.colourStepperConnectorInactive,
    connectorActiveBorderColor: a.colourStepperConnectorSuccess
  },
  tab: {
    borderActive: a.colourTabsBorderActive,
    borderInActive: a.colourTabsBorderInactive,
    paddingBottom: a.spacingTabsVerticalGap,
    titleTextActiveColor: a.colourTabsTextTitle,
    titleTextInactiveColor: a.colourTabsTextTitleInactive,
    subtitleTextActiveColor: a.colourTabsTextSubtitle,
    subtitleTextInActiveColor: a.colourTabsTextSubtitleInactive,
    iconColorActive: a.colourTabsIconActive,
    iconColorInActive: a.colourTabsIconInactive,
    iconSize: a.sizingTabsIcon,
    borderWidthTabsActive: a.borderWidthTabsActive,
    // Todo: replace with tokens in DLS-2018
    bottomBorderColor: "#E1E1E1",
    tabBarDividerPositionBottom: 0,
    tabItemContainerPadding: "16px 24px 8px",
    selectedTabTitleColor: "#5C50BB",
    tabTitleColor: "#222222",
    tabItemContainerHoverBg: "#DEDAFAcc",
    tabItemContainerBg: "#FFFFFF",
    tabItemIndicatorBgColor: "#5C50BB",
    tabBarDividerBgColor: "#E1E1E1"
  }
}), BT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  baseTheme: mn,
  breakpoints: ro,
  dlsStandard: IT,
  dlsStandard1: gT
}, Symbol.toStringTag, { value: "Module" })), r = Qo(xn), bT = {
  text: fo,
  button: {
    minWidth: 128,
    minHeight: 40,
    textColor: r.colourButtonTextPrimary,
    textColorInvert: r.colourButtonTextPrimaryInverse,
    iconColor: r.colourButtonIconPrimary,
    iconColorInvert: r.colourButtonIconPrimaryInverse,
    borderRadius: r.borderRadiusButton,
    paddingVertical: r.spacingButtonPaddingVertical,
    paddingHorizontal: r.spacingButtonPaddingHorizontal,
    backgroundColor: r.colourButtonBackgroundPrimary,
    backgroundInverse: r.colourButtonBackgroundPrimaryInverse,
    backgroundColorPressed: r.colourButtonBackgroundPrimaryPressed,
    backgroundColorInversePressed: r.colourButtonBackgroundPrimaryInversePressed,
    iconColorSuccess: r.colourButtonIconSuccess,
    backgroundSuccess: r.colourButtonBackgroundSuccess,
    rippleBackgroundColor: mo,
    secondary: {
      background: "none",
      borderWidth: r.borderWidthButtonSecondary,
      borderColor: r.colourButtonSecondaryBorder,
      textColor: r.colourButtonTextSecondary,
      textColorInverse: r.colourButtonTextSecondaryInverse,
      borderColorInvert: r.colourButtonSecondaryBorderInverse,
      iconColor: r.colourButtonIconSecondary,
      iconColorInvert: r.colourButtonIconSecondaryInverse
    },
    mini: {
      minHeight: 32,
      minWidth: 120,
      paddingVertical: r.spacingButtonMiniPaddingVertical,
      paddingHorizontal: r.spacingButtonPaddingHorizontal
    }
  },
  formField: {
    backgroundColorError: p
  },
  formFieldHint: {
    marginTop: C
  },
  textInput: {
    height: 64,
    textFontSize: fo.body.fontSize,
    headerSize: fo.smallBody.fontSize,
    defaultBackgroundColor: r.colourInputBackground,
    hazaBackgroundColor: r.colourInputBackgroundHaze,
    activeBorderColor: r.colourInputBorderActive,
    errorBorderColor: r.colourInputBorderError,
    labelColor: r.colourInputTextLabel,
    labelActiveColor: r.colourInputTextLabelActive,
    textColor: r.colourInputTextActive,
    hintColor: r.colourInputTextHint,
    errorTextColor: r.colourInputTextError,
    counterColor: r.colourInputTextCounter,
    iconColor: r.colourInputIconStandard,
    spacingTopError: r.spacingInputTextErrorPaddingTop,
    borderWidth: r.borderWidthInputStandard,
    paddingHorizontal: r.spacingInputPaddingHorizontal,
    selectionColor: Uo,
    paddingVertical: r.spacingInputPaddingVerticalActive,
    areaLineHeight: fo.body.lineHeight,
    overlayHeaderPosition: {
      android: [-2, -5],
      ios: [-1, -6]
    }
  },
  hintText: {
    fontSize: u
  },
  dropDownInput: {
    rowHeight: {
      ios: 40,
      android: 38
    },
    imageSize: r.sizingInputImageFlag,
    dropdownBackgroundColor: r.colourDrawerBackgroundStandard,
    headerColor: r.colourDrawerTextLabel,
    headerBackgroundColor: r.colourDrawerBackgroundLabel,
    seclectedItemColor: r.colourDrawerTextTitle,
    borderDrawer: r.borderRadiusDrawerTopLeft,
    borderCenterItemColor: void 0,
    // will update when component token is ready
    horizontalSpacing: r.spacingDrawerListOptionPaddingHorizontal
  },
  checkBoxInput: {
    boxBackgroundColor: r.colourCheckboxInputBackgroundStandard,
    boxActiveBackgroundColor: r.colourCheckboxInputBackgroundActive,
    boxBorderColor: r.colourCheckboxInputBorderStandard,
    boxBorderErrorColor: r.colourCheckboxInputBorderError,
    labelColor: r.colourInputTextLabel,
    tickColor: r.colourInputIconInverse,
    textErrorColor: r.colourInputTextError,
    boxWidth: r.borderWidthInputStandard,
    boxAndLabelGap: r.spacingInputHorizontalGap,
    errorTopGap: r.spacingInputTextErrorPaddingTop
  },
  radioInput: {
    textColor: r.colourInputTextLabel,
    backgroundColor: r.colourRadioInputBackgroundStandard,
    backgroundActiveColor: r.colourRadioInputBackgroundActive,
    inputSize: 24,
    textPaddingLeft: r.spacingInputHorizontalGap,
    borderColor: r.colourRadioInputBorderStandard,
    topSpacingError: r.spacingInputTextErrorPaddingTop,
    textErrorColor: r.colourInputTextError,
    borderErrorColor: r.colourRadioInputBorderError
  },
  quantityInput: {
    textNumberColor: r.colourInputTextNumber,
    iconActiveBgColor: r.colourInputIconBackgroundActive,
    iconDisabledBgColor: r.colourInputIconBackgroundDisabled,
    labelMarginRight: r.spacingInputTextLabelPaddingRight,
    numberHorizontalSpacing: r.spacingInputTextNumberPaddingHorizontal,
    iconColor: r.colourInputIconInverse,
    iconSize: 24,
    boxBackgroundColor: r.colourInputBackground,
    boxHorizontalSpacing: r.spacingInputPaddingHorizontal,
    boxVerticalSpacing: r.spacingInputPaddingVertical
  },
  fileInput: {
    fontFamily: $,
    fontSize: l,
    fontSizeLabelText: u,
    fontWeightLabelText: no
  },
  iconButton: {
    fontFamily: $,
    fontSize: u,
    fontWeight: W
  },
  calendar: {
    textDayColor: r.colourCalendarTextDay,
    textMonthColor: r.colourCalendarTextMonth,
    textDateColor: r.colourCalendarTextDate,
    textDateSelectedColor: r.colourCalendarTextDateSelected,
    textDateDisabledColor: r.colourCalendarTextDateStrikethrough,
    backgroundSelectedColor: r.colourCalendarBackgroundSelected,
    backgroundSelectedRangeColor: r.colourCalendarBackgroundSelectedRange,
    backgroundDayColor: r.colourCalendarBackgroundDay,
    wrapperPaddingHorizontal: r.spacingCalendarPaddingHorizontal,
    monthPaddingVertical: r.spacingCalendarMonthPaddingVertical,
    daysPaddingVertical: r.spacingCalendarDayPaddingVertical,
    datesVerticalGap: r.spacingCalendarDatesVerticalGap,
    selectedDateBoxSize: r.sizingCalendarDate,
    dateBoxSize: r.sizingCalendarDay
  },
  otpPinInput: {
    inputBackgroundColor: r.colourInputBackground,
    inputBackgroundColorHaze: r.colourInputBackgroundHaze,
    borderActiveColor: r.colourInputBorderActive,
    borderErrorColor: r.colourInputBorderError,
    textActiveColor: r.colourInputTextActive,
    textHintColor: r.colourInputTextHint,
    textErrorColor: r.colourInputTextError,
    textLoadingColor: r.colourInputTextLoading,
    iconLoaderColor: r.colourInputIconLoader,
    errorTopGap: r.spacingInputTextErrorPaddingTop,
    borderRadius: r.borderRadiusInput
  },
  link: fo.link,
  card: {
    backgroundColor: r.colourCardBackground,
    borderRadius: r.borderRadiusCardBigImage || 16,
    titleColor: r.colourCardTextTitle,
    subtitleColor: r.colourCardTextSubtitle,
    contentHorizontalPadding: r.spacingCardThumbnailPaddingHorizontal,
    iconTitleColor: r.colourCardIconTitle,
    iconSubtitle: r.colourCardIconSubtitle,
    bodyColor: r.colourCardTextBody,
    shadow: sn,
    headerTextColor: r.colourCardTextHeader,
    deviderGap: r.spacingCardContentVerticalGap,
    ribbonBottomGap: r.spacingCardThumbnailTextRibbonPaddingBottom,
    topSpacingIconSubtitle: 1,
    thumbnail: {
      borderRadius: r.borderRadiusCardThumbnail || 8,
      verticalSpacing: r.spacingCardThumbnailPaddingVertical,
      rightSpacing: r.spacingCardTitleImagePaddingRight || 16,
      imageMd: r.sizingCardThumbnailMd,
      imageLg: r.sizingCardThumbnailLg,
      imageXl: r.sizingCardThumbnailXl
    },
    bigImage: {
      bottomGap: r.spacingCardBigImagePaddingBottom,
      titleTopGap: r.spacingCardBigImagePaddingTop,
      contentTopGap: r.spacingCardBigImageTextBodyPaddingTop,
      buttonTopGap: r.spacingCardBigImageButtonPaddingTop,
      horizontalSpace: r.spacingCardBigImagePaddingHorizontal
    },
    copyClipboard: {
      verticalSpacing: r.spacingCardCopyClipboardPaddingVertical
    }
  },
  tag: {
    backgroundPrimary: r.colourTagBackgroundPrimary,
    backgroundSecondary: r.colourTagBackgroundSecondary,
    borderRadius: r.borderRadiusTag,
    minHeightTall: r.sizingTagTall,
    minHeightShort: r.sizingTagShort,
    textColor: r.colourTagText
  },
  ribbon: {
    rightIconGap: r.spacingRibbonHorizontalGap,
    iconSize: r.sizingRibbonIcon,
    primary: {
      textColor: r.colourRibbonTextPrimary,
      iconColor: r.colourRibbonIconPrimary,
      iconBackground: r.colourRibbonIconBackgroundPrimary
    },
    secondary: {
      textColor: r.colourRibbonTextSecondary,
      iconColor: r.colourRibbonIconSecondary,
      iconBackground: r.colourRibbonIconBackgroundSecondary
    }
  },
  modal: {
    backgroundColor: r.colourModalBackground,
    overlayBackground: r.colourModalOverlay,
    headerTextColor: r.colourModalTextHeader,
    borderRadius: r.borderRadiusModal,
    contentSpacingHorizontal: r.spacingModalCardPaddingHorizontal,
    contentSpacingVertical: r.spacingModalCardPaddingTop,
    boxMarginHorizontal: r.spacingModalPaddingHorizontal,
    iconCloseColor: r.colourModalIcon,
    stickyPaddingVertical: r.spacingModalButtonStickyPaddingVertical,
    titleMargin: M,
    hazaBackgroundColor: w,
    gradientBottomColor: w
  },
  listItem: {
    titleColor: r.colourListItemTextTitle,
    subtitleColor: r.colourListItemTextSubtitle,
    borderRadius: r.borderRadiusListItem,
    bodyPaddingLeft: r.spacingListItemImagePaddingRight,
    bodyPaddingRight: r.spacingListItemIconPaddingLeft,
    imageSize: r.sizingListItemImageThumbnail,
    imageThumbnailSize: r.sizingListItemImageImage,
    iconSubtitleColor: r.colourListItemIconSubtle,
    iconSubtitleSize: r.sizingListItemImageIconLg,
    backgroundColor: r.colourListItemBackground,
    leftContainerBackground: r.colourListItemIconBackground,
    leftIconSize: r.sizingListItemIconImage,
    leftIconColor: r.colourListItemIcon,
    leftContainerPaddingIcon: r.spacingListItemIconIconPaddingVertical,
    leftContainerPaddingIconImage: r.spacingListItemIconImagePaddingVertical,
    rightIconSize: r.sizingListItemIconIconStatus,
    pointIconColor: r.colourListItemTextPoints
  },
  toggle: {
    backgroundColor: r.colourToggleBase,
    activeBackground: r.colourToggleBaseActive,
    iconOnColor: r.colourToggleOn,
    iconOffColor: r.colourToggleOff
  },
  carousel: {
    titleColor: r.colourCarouselTextTitle,
    inverseTitleColor: r.colourCarouselTextTitleInverse,
    bodyColor: r.colourCarouselTextBody,
    inverseBodyColor: r.colourCarouselTextBodyInverse,
    indicatorActiveColor: r.colourCarouselIndicatorActive,
    indicatorInactiveColor: r.colourCarouselIndicatorInactive,
    ctaTopGap: r.spacingCarouselTextVerticalGap,
    overlayBackgroundColor: r.colourCarouselOverlay,
    borderRadius: r.borderRadiusCarouselFixed,
    wrapperTopSpacing: r.spacingCarouselPaddingTop,
    wrapperHorizontalSpacing: r.spacingCarouselPaddingHorizontal
  },
  drawer: {
    backgroundColor: r.colourDrawerBackgroundStandard,
    backgroundOverlay: r.colourDrawerBackgroundOverlay,
    handleColor: r.colourDrawerHandle,
    topGapHandle: r.spacingDrawerHandlePaddingTop,
    contentSpacingHorizontal: r.spacingDrawerPaddingHorizontal,
    borderRadiusTopLeft: r.borderRadiusDrawerTopLeft,
    borderRadiusTopRight: r.borderRadiusDrawerTopRight,
    hazaBackgroundColor: w,
    widthHandle: r.sizingDrawerHandle,
    headerBottomSpacing: r.spacingDrawerVerticalGap,
    // with search
    backgroundSelected: r.colourDrawerBackgroundSelected,
    textHeaderColor: r.colourDrawerTextHeader,
    textHintColor: r.colourDrawerTextHint,
    titlePinnedColor: r.colourDrawerTextTitlePinned,
    textTitleColor: r.colourDrawerTextTitle,
    textSubtitleColor: r.colourDrawerTextSubtitle,
    textStrikethrough: r.colourDrawerTextStrikethrough,
    listOptionsPaddingVetical: r.spacingInputListOptionsPaddingVertical,
    listOptionsPaddingHorizontal: r.spacingInputListOptionsPaddingHorizontal,
    listOptionPaddingVertial: r.spacingDrawerListOptionPaddingVertical,
    listOptionPaddingHorizontal: r.spacingDrawerListOptionPaddingHorizontal,
    listOptionHorizontalGap: r.spacingDrawerListOptionHorizontalGap,
    flagPaddingRight: r.spacingDrawerImageFlagPaddingRight,
    thumbnailPaddingRight: r.spacingDrawerImageThumbnailPaddingRight,
    listVerticalGap: r.spacingDrawerListVerticalGap,
    flagSize: r.sizingDrawerImageFlag,
    thumbnailSize: r.sizingDrawerImageThumbnail,
    headerPaddingTop: r.spacingDrawerHeaderPaddingTop,
    iconColor: r.colourDrawerIcon
  },
  stickyFooter: {
    boxHorizontalGap: r.spacingStickyFooterPaddingHorizontal,
    boxVerticalGap: r.spacingStickyFooterPaddingVertical,
    backgroundColor: r.colourStickyFooterBackground,
    borderTopDividerColor: r.colourStickyFooterBorderTop,
    buttonAndLinkGap: r.spacingStickyFooterTextLinkVerticalGap,
    variantHorizontalGap: r.spacingStickyFooterHorizontalGap,
    strikethroughTextColor: r.colourStickyFooterPriceStrikethrough
  },
  divider: {
    barColor: r.colourDivider10Horizontal,
    width: r.borderWidthDividerStandard,
    sectionTitleColor: r.colourDivider10Text,
    titleHorizontalGap: r.spacingDividerHorizontalGap
  },
  accordion: {
    titleColor: r.colourAccordionTextTitle,
    bodyColor: r.colourAccordionTextBody,
    iconColor: r.colourAccordionIcon,
    horizontalGap: r.spacingAccordionHorizontalGap,
    titlePaddingVertical: r.spacingAccordionTitlePaddingVertical,
    bodyPaddingBottom: r.spacingAccordionBodyPaddingBottom,
    iconSize: r.sizingAccordionIcon
  },
  bulletList: {
    textColor: r.colourBulletListText,
    iconColor: r.colourBulletListIcon,
    textHorizontalGap: r.spacingBulletListHorizontalGap,
    iconLeftSpacing: r.spacingBulletListPaddingLeft,
    textHorizontalGapSm: r.spacingBulletListHorizontalGapSm,
    iconSize: r.sizingBulletListIcon,
    iconSizeSm: r.sizingBulletListIconSm,
    bulletPointTopMarginBody: 9,
    bulletPointTopMarginSmallBody: 7
  },
  notification: {
    textTitle: r.colourNotificationTextTitle,
    textBody: r.colourNotificationTextBody,
    backgroundAlert: r.colourNotificationBackgroundAlert,
    backgroundInfo: r.colourNotificationBackgroundInfo,
    backgroundPromo: r.colourNotificationBackgroundPromo,
    boxHorizontalPadding: r.spacingNotificationPaddingHorizontal,
    boxHorizontalPaddingLg: r.spacingNotificationPaddingHorizontalLg,
    boxVerticalPadding: r.spacingNotificationPaddingVertical,
    buttonAndTextVerticalGap: r.spacingNotificationVerticalGap,
    iconColor: r.colourNotificationIcon,
    iconAndContentHorizontalGap: r.spacingNotificationHorizontalGap,
    linkAndContentVerticalGap: r.spacingNotificationTextLinkPaddingTop,
    iconSize: r.sizingNotificationIcon,
    borderRadius: r.borderRadiusNotification
  },
  circlePattern: {
    paddingTop: r.spacingCirclePatternVariant1TextPaddingTop,
    imageSizeVariant1: r.sizingCirclePatternVariant1,
    imageSizeVariant2: r.sizingCirclePatternVariant2,
    thumbnailVariant2PaddingLeft: r.spacingCirclePatternVariant2TextPaddingLeft
  },
  selector: {
    borderColorActive: r.colourSelectorBorderActive,
    borderWidthActive: r.borderWidthSelectorActive,
    borderColorStandard: r.colourSelectorBorderStandard,
    borderWidthStandard: r.borderWidthSelectorStandard,
    borderWidth: r.borderWidthSelectorActive,
    paddingTop: r.spacingSelectorPaddingVertical,
    paddingRight: r.spacingSelectorPaddingHorizontal,
    paddingBottom: r.spacingSelectorPaddingVertical,
    paddingLeft: r.spacingSelectorPaddingHorizontal,
    disabledMsgColor: r.colourSelectorTextUnavailable,
    subtitleTextColor: r.colourSelectorTextSubtitle,
    disabledTitleTextColor: r.colourSelectorTextDisabled,
    subTitlePaddingTop: r.spacingSelectorTextSubtitlePaddingTop
  },
  toast: {
    iconSuccessColor: r.colourToastIconSuccess,
    iconPendingColor: r.colourToastIconPending,
    iconAlertColor: r.colourToastIconAlert,
    itemSpacing: r.spacingToastHorizontalGap,
    backgroundColor: r.colourToastBackground,
    textColor: r.colourToastTextLinkInverse,
    borderRadius: r.borderRadiusToast,
    padding: r.spacingToastPaddingHorizontal
  },
  stepper: {
    outerSize: r.sizingStepperOuter,
    outerBorderColor: r.colourStepperBorderActive,
    colorTextActive: r.colourStepperTextActive,
    colorTextInactive: r.colourStepperTextInactive,
    backgroundColorActive: r.colourStepperBackgroundActive,
    backgroundColorInActive: r.colourStepperBackgroundInactive,
    colorIconSuccess: r.colourStepperBackgroundSuccess,
    innerSize: r.sizingStepperInner,
    backgroundColorSuccess: r.colourStepperIconSuccess,
    colorConnectorSuccess: r.colourStepperConnectorSuccess,
    colorConnectorInactive: r.colourStepperConnectorInactive
  },
  topNavigation: {
    backButtonColor: r.colourTopNavigationIconStandard,
    titleColor: r.colourTopNavigationTextStandard,
    colorBorderBottom: r.colourTopNavigationBorderBottom,
    backgroundColor: r.colourTopNavigationBackground,
    backgroundColorHaze: r.colourTopNavigationBackgroundHaze,
    paddingHorizontal: r.spacingTopNavigationHorizontalGap,
    iconButtonSize: r.sizingTopNavigationIcon,
    backgroundColorGradient: r.colourTopNavigationGradient,
    titleColorInverse: r.colourTopNavigationTextInverse,
    iconColorInverse: r.colourInputIconInverse
  },
  heroBanner: {
    titleColor: r.colourHeroBannerTextTitle,
    titleColorInverse: r.colourHeroBannerTextTitleInverse,
    subtitleColor: r.colourHeroBannerTextSubtitle,
    subtitleColorInverse: r.colourHeroBannerTextSubtitleInverse,
    indicatorColorInactive: r.colourHeroBannerIndicatorInactive,
    indicatorColorActive: r.colourHeroBannerIndicatorActive,
    indicatorPaddingBottom: r.spacingHeroBannerIndicatorPaddingBottom,
    indicatorHorizontalGap: r.spacingHeroBannerIndicatorHorizontalGap,
    textPaddingHorizontal: r.spacingHeroBannerTextPaddingHorizontal
  },
  tabs: {
    titleColor: r.colourTabsTextTitle,
    titleColorInactive: r.colourTabsTextTitleInactive,
    subtitleColor: r.colourTabsTextSubtitle,
    subtitleColorInactive: r.colourTabsTextSubtitleInactive,
    borderColorInactive: r.colourTabsBorderInactive,
    borderColorActive: r.colourTabsBorderActive,
    borderWidth: r.borderWidthTabsStandard,
    borderWidthActive: r.borderWidthTabsActive,
    tabVerticalGap: r.spacingTabsVerticalGap,
    tabPaddingHorizontal: r.spacingTabsPaddingHorizontal,
    //icons
    tabIconActive: r.colourTabsIconActive,
    tabIconInactive: r.colourTabsIconInactive,
    tabIconSize: r.sizingTabsIcon,
    tabsIconVerticalGap: r.spacingTabsIconVerticalGap
  },
  swimlane: {
    horizontalSpacing: r.spacingSwimlaneHorizontalGapMd
  },
  voucher: {
    colourVoucherBackground: r.colourVoucherBackground,
    colourVoucherTextTitle: r.colourVoucherTextTitle,
    colourVoucherTextSubtitle: r.colourVoucherTextSubtitle,
    colourVoucherTextSubtitleExpiring: r.colourVoucherTextSubtitleExpiring,
    colourVoucherTextPoints: r.colourVoucherTextPoints,
    colourVoucherIcon: r.colourVoucherIcon,
    borderRadiusVoucher: r.borderRadiusVoucher,
    spacingVoucherListViewTextPaddingHorizontal: r.spacingVoucherListViewTextPaddingHorizontal,
    spacingVoucherListViewTextVerticalGap: r.spacingVoucherListViewTextVerticalGap,
    spacingVoucherListViewTextPointsPaddingLeft: r.spacingVoucherListViewTextPointsPaddingLeft,
    sizingVoucherImage: r.sizingVoucherImage,
    sizingVoucherIcon: r.sizingVoucherIcon,
    shadowVoucherLow: r.shadowVoucherLow,
    colourVoucherBackgroundRedeemed: r.colourVoucherBackgroundRedeemed,
    colourVoucherTextTitleRedeemed: r.colourVoucherTextTitleRedeemed,
    colourVoucherTextSubtitleRedeemed: r.colourVoucherTextSubtitleRedeemed,
    colourVoucherTextPointsRedeemed: r.colourVoucherTextPointsRedeemed
  }
}, TT = {
  fontFamily: {
    primary: $,
    secondary: lr
  },
  fontSize: {
    sm: k,
    md: l,
    lg: L,
    xl: V,
    xxl: z
  },
  colors: {
    primary: {
      10: tr,
      20: Cd,
      30: yo,
      40: vd,
      50: J,
      60: ao,
      70: Mo,
      80: zd
    },
    secondary: {
      10: Ho,
      20: Ko,
      30: cn,
      40: H,
      50: cr,
      60: ln
    },
    neutral: {
      0: p,
      10: w,
      20: P,
      30: A,
      40: G,
      50: ko,
      60: jo,
      70: y,
      // Check these colors with the Design team
      80: "#121212",
      100: fd
    },
    status: {
      success: io,
      error: Mo,
      pending: Lo
    }
  },
  card: {
    body: {},
    container: {
      backgroundColor: void 0
    },
    textLink: {},
    title: {}
  },
  screen: {
    container: { backgroundColor: void 0 },
    containerHaze: { backgroundColor: void 0 }
  },
  text: {
    color: void 0
  },
  button: {
    primary: { textColor: p }
  },
  circularProgressBar: {
    title: { fontWeight: void 0 },
    subTitle: { fontWeight: void 0 }
  },
  PINInput: {
    loadingAnimation: {
      color: void 0
    },
    cursor: {
      color: void 0
    }
  }
}, n = Qo(Bn), _o = {
  fontSize: k,
  lineHeight: k * 1.75,
  letterSpacing: 0.2
}, ST = S(g({}, TT), {
  text: {
    color: y,
    error: {
      color: Mo
    },
    bannerTitle: {
      fontSize: z,
      fontFamily: x.secondary.museo100,
      lineHeight: z * 1.3,
      letterSpacing: 0.1
    },
    pageTitle: {
      fontSize: z,
      fontFamily: x.secondary.museo300,
      lineHeight: z * 1.35,
      letterSpacing: 0.1
    },
    sectionTitle: {
      fontSize: V,
      fontFamily: x.primary.latoBlack,
      lineHeight: V * 1.35,
      letterSpacing: 0.1
    },
    header: {
      fontFamily: x.primary.latoBold,
      fontSize: L,
      lineHeight: L * 1.35
    },
    boldBody: {
      fontFamily: x.primary.latoBold,
      fontSize: l,
      lineHeight: l * 1.75
    },
    body: {
      fontFamily: x.primary.latoRegular,
      fontSize: l,
      lineHeight: l * 1.75,
      letterSpacing: 0.1,
      color: y
    },
    smallBody: S(g({}, _o), {
      fontFamily: x.primary.latoRegular
    }),
    smallBodySemiBold: S(g({}, _o), {
      fontFamily: x.primary.latoSemibold
    }),
    smallBodyBold: S(g({}, _o), {
      fontFamily: x.primary.latoBold
    }),
    link: {
      fontFamily: x.primary.latoBold,
      fontSize: l,
      lineHeight: l * 1.75,
      letterSpacing: 0.1,
      color: H,
      textDecorationLine: "underline"
    },
    smallBodyLink: {
      fontFamily: x.primary.latoBold,
      fontSize: u,
      lineHeight: u * 1.75,
      letterSpacing: 0.1,
      textDecorationLine: "underline",
      color: H
    },
    fontBold: {
      fontFamily: x.primary.latoBold
    },
    fontSemibold: {
      fontFamily: x.primary.latoSemibold
    }
  },
  button: {
    minWidth: 128,
    minHeight: 40,
    textColor: n.colourButtonTextPrimary,
    textColorInvert: n.colourButtonTextPrimaryInverse,
    iconColor: n.colourButtonIconPrimary,
    iconColorInvert: n.colourButtonIconPrimaryInverse,
    borderRadius: n.borderRadiusButton,
    paddingVertical: n.spacingButtonPaddingVertical,
    paddingHorizontal: n.spacingButtonPaddingHorizontal,
    backgroundColor: n.colourButtonBackgroundPrimary,
    backgroundInverse: n.colourButtonBackgroundPrimaryInverse,
    backgroundColorPressed: J + "80",
    rippleBackgroundColor: Ko,
    backgroundColorInversePressed: n.colourButtonBackgroundPrimaryInversePressed,
    iconColorSuccess: n.colourButtonIconSuccess,
    backgroundSuccess: n.colourButtonBackgroundSuccess,
    secondary: {
      background: "none",
      borderWidth: n.borderWidthButtonSecondary,
      borderColor: n.colourButtonSecondaryBorder,
      textColor: n.colourButtonTextSecondary,
      textColorInverse: n.colourButtonTextSecondaryInverse,
      borderColorInvert: n.colourButtonSecondaryBorderInverse,
      iconColor: n.colourButtonIconSecondary,
      iconColorInvert: n.colourButtonIconSecondaryInverse
    },
    mini: {
      minHeight: 32,
      minWidth: 120,
      paddingVertical: n.spacingButtonMiniPaddingVertical,
      paddingHorizontal: n.spacingButtonPaddingHorizontal
    }
  },
  formField: {
    backgroundColorError: p
  },
  formFieldHint: {
    marginTop: C
  },
  textInput: {
    height: 64,
    textFontSize: l,
    headerSize: _o.fontSize,
    defaultBackgroundColor: n.colourInputBackground,
    hazaBackgroundColor: n.colourInputBackgroundHaze,
    activeBorderColor: n.colourInputBorderActive,
    errorBorderColor: n.colourInputBorderError,
    labelColor: H,
    labelActiveColor: n.colourInputTextLabelActive,
    textColor: n.colourInputTextActive,
    hintColor: n.colourInputTextHint,
    errorTextColor: n.colourInputTextError,
    counterColor: n.colourInputTextCounter,
    iconColor: n.colourInputIconStandard,
    spacingTopError: n.spacingInputTextErrorPaddingTop,
    borderWidth: n.borderWidthInputStandard,
    paddingHorizontal: n.spacingInputPaddingHorizontal,
    selectionColor: H,
    paddingVertical: n.spacingInputPaddingVerticalActive,
    areaLineHeight: 24,
    overlayHeaderPosition: {
      android: [-2, -7],
      ios: [-1, -8]
    }
  },
  hintText: {
    fontSize: u
  },
  dropDownInput: {
    rowHeight: {
      ios: 40,
      android: 38
    },
    imageSize: n.sizingInputImageFlag,
    dropdownBackgroundColor: n.colourDrawerBackgroundStandard,
    headerColor: H,
    headerBackgroundColor: n.colourDrawerBackgroundLabel,
    seclectedItemColor: H,
    borderDrawer: n.borderRadiusDrawerTopLeft,
    borderCenterItemColor: "",
    //colors.divider10, // will update when component token is ready
    horizontalSpacing: n.spacingDrawerListOptionPaddingHorizontal
  },
  checkBoxInput: {
    boxBackgroundColor: n.colourCheckboxInputBackgroundStandard,
    boxActiveBackgroundColor: n.colourCheckboxInputBackgroundActive,
    boxBorderColor: n.colourCheckboxInputBorderStandard,
    boxBorderErrorColor: n.colourCheckboxInputBorderError,
    labelColor: n.colourInputTextLabel,
    tickColor: n.colourInputIconInverse,
    textErrorColor: n.colourInputTextError,
    boxWidth: n.borderWidthInputStandard,
    boxAndLabelGap: n.spacingInputHorizontalGap,
    errorTopGap: n.spacingInputTextErrorPaddingTop
  },
  radioInput: {
    textColor: n.colourInputTextLabel,
    backgroundColor: n.colourRadioInputBackgroundStandard,
    backgroundActiveColor: n.colourRadioInputBackgroundActive,
    inputSize: 24,
    textPaddingLeft: n.spacingInputHorizontalGap,
    borderColor: n.colourRadioInputBorderStandard,
    topSpacingError: n.spacingInputTextErrorPaddingTop,
    textErrorColor: n.colourInputTextError,
    borderErrorColor: n.colourRadioInputBorderError
  },
  quantityInput: {
    textNumberColor: n.colourInputTextNumber,
    iconActiveBgColor: n.colourInputIconBackgroundActive,
    iconDisabledBgColor: n.colourInputIconBackgroundDisabled,
    labelMarginRight: n.spacingInputTextLabelPaddingRight,
    numberHorizontalSpacing: n.spacingInputTextNumberPaddingHorizontal,
    iconColor: n.colourInputIconInverse,
    iconSize: 24,
    boxBackgroundColor: n.colourInputBackground,
    boxHorizontalSpacing: n.spacingInputPaddingHorizontal,
    boxVerticalSpacing: n.spacingInputPaddingVertical
  },
  fileInput: {
    fontFamily: $,
    fontSize: l,
    fontSizeLabelText: u,
    fontWeightLabelText: no
  },
  iconButton: {
    fontFamily: $,
    fontSize: u,
    fontWeight: W
  },
  calendar: {
    textDayColor: n.colourCalendarTextDay,
    textMonthColor: n.colourCalendarTextMonth,
    textDateColor: n.colourCalendarTextDate,
    textDateSelectedColor: n.colourCalendarTextDateSelected,
    textDateDisabledColor: n.colourCalendarTextDateStrikethrough,
    backgroundSelectedColor: n.colourCalendarBackgroundSelected,
    backgroundSelectedRangeColor: n.colourCalendarBackgroundSelectedRange,
    backgroundDayColor: n.colourCalendarBackgroundDay,
    wrapperPaddingHorizontal: n.spacingCalendarPaddingHorizontal,
    monthPaddingVertical: n.spacingCalendarMonthPaddingVertical,
    daysPaddingVertical: n.spacingCalendarDayPaddingVertical,
    datesVerticalGap: n.spacingCalendarDatesVerticalGap,
    selectedDateBoxSize: n.sizingCalendarDate,
    dateBoxSize: n.sizingCalendarDay
  },
  otpPinInput: {
    inputBackgroundColor: n.colourInputBackground,
    inputBackgroundColorHaze: n.colourInputBackgroundHaze,
    borderActiveColor: n.colourInputBorderActive,
    borderErrorColor: n.colourInputBorderError,
    textActiveColor: n.colourInputTextActive,
    textHintColor: n.colourInputTextHint,
    textErrorColor: n.colourInputTextError,
    textLoadingColor: n.colourInputTextLoading,
    iconLoaderColor: n.colourInputIconLoader,
    errorTopGap: n.spacingInputTextErrorPaddingTop,
    borderRadius: n.borderRadiusInput
  },
  link: {
    color: H
  },
  card: {
    backgroundColor: n.colourCardBackground,
    borderRadius: n.borderRadiusCardBigImage || 16,
    titleColor: n.colourCardTextTitle,
    subtitleColor: n.colourCardTextSubtitle,
    contentHorizontalPadding: n.spacingCardThumbnailPaddingHorizontal,
    iconTitleColor: n.colourCardIconTitle,
    iconSubtitle: n.colourCardIconSubtitle,
    bodyColor: n.colourCardTextBody,
    shadow: sn,
    headerTextColor: n.colourCardTextHeader,
    deviderGap: n.spacingCardContentVerticalGap,
    ribbonBottomGap: n.spacingCardThumbnailTextRibbonPaddingBottom,
    topSpacingIconSubtitle: 4,
    thumbnail: {
      borderRadius: n.borderRadiusCardThumbnail || 8,
      verticalSpacing: n.spacingCardThumbnailPaddingVertical,
      rightSpacing: n.spacingCardTitleImagePaddingRight || 16,
      imageMd: n.sizingCardThumbnailMd,
      imageLg: n.sizingCardThumbnailLg,
      imageXl: n.sizingCardThumbnailXl
    },
    bigImage: {
      bottomGap: n.spacingCardBigImagePaddingBottom,
      titleTopGap: n.spacingCardBigImagePaddingTop,
      contentTopGap: n.spacingCardBigImageTextBodyPaddingTop,
      buttonTopGap: n.spacingCardBigImageButtonPaddingTop,
      horizontalSpace: n.spacingCardBigImagePaddingHorizontal
    },
    copyClipboard: {
      verticalSpacing: n.spacingCardCopyClipboardPaddingVertical
    }
  },
  tag: {
    backgroundPrimary: n.colourTagBackgroundPrimary,
    backgroundSecondary: n.colourTagBackgroundSecondary,
    borderRadius: n.borderRadiusTag,
    minHeightTall: n.sizingTagTall,
    minHeightShort: n.sizingTagShort,
    textColor: n.colourTagText
  },
  ribbon: {
    rightIconGap: n.spacingRibbonHorizontalGap,
    iconSize: n.sizingRibbonIcon,
    primary: {
      textColor: n.colourRibbonTextPrimary,
      iconColor: n.colourRibbonIconPrimary,
      iconBackground: n.colourRibbonIconBackgroundPrimary
    },
    secondary: {
      textColor: n.colourRibbonTextSecondary,
      iconColor: n.colourRibbonIconSecondary,
      iconBackground: n.colourRibbonIconBackgroundSecondary
    }
  },
  modal: {
    backgroundColor: n.colourModalBackground,
    overlayBackground: n.colourModalOverlay,
    headerTextColor: n.colourModalTextHeader,
    borderRadius: n.borderRadiusModal,
    contentSpacingHorizontal: n.spacingModalCardPaddingHorizontal,
    contentSpacingVertical: n.spacingModalCardPaddingTop,
    boxMarginHorizontal: n.spacingModalPaddingHorizontal,
    iconCloseColor: n.colourModalIcon,
    stickyPaddingVertical: n.spacingModalButtonStickyPaddingVertical,
    titleMargin: M,
    hazaBackgroundColor: w
  },
  listItem: {
    titleColor: n.colourListItemTextTitle,
    subtitleColor: n.colourListItemTextSubtitle,
    borderRadius: n.borderRadiusListItem,
    bodyPaddingLeft: n.spacingListItemImagePaddingRight,
    bodyPaddingRight: n.spacingListItemIconPaddingLeft,
    imageSize: n.sizingListItemImageThumbnail,
    imageThumbnailSize: n.sizingListItemImageImage,
    iconSubtitleColor: n.colourListItemIconSubtle,
    iconSubtitleSize: n.sizingListItemImageIconLg,
    backgroundColor: n.colourListItemBackground,
    leftContainerBackground: n.colourListItemIconBackground,
    leftIconSize: n.sizingListItemIconImage,
    leftIconColor: n.colourListItemIcon,
    leftContainerPaddingIcon: n.spacingListItemIconIconPaddingVertical,
    leftContainerPaddingIconImage: n.spacingListItemIconImagePaddingVertical,
    rightIconSize: n.sizingListItemIconIconStatus,
    pointIconColor: n.colourListItemTextPoints
  },
  toggle: {
    backgroundColor: n.colourToggleBase,
    activeBackground: n.colourToggleBaseActive,
    iconOnColor: n.colourToggleOn,
    iconOffColor: n.colourToggleOff
  },
  carousel: {
    titleColor: n.colourCarouselTextTitle,
    inverseTitleColor: n.colourCarouselTextTitleInverse,
    bodyColor: n.colourCarouselTextBody,
    inverseBodyColor: n.colourCarouselTextBodyInverse,
    indicatorActiveColor: n.colourCarouselIndicatorActive,
    indicatorInactiveColor: n.colourCarouselIndicatorInactive,
    ctaTopGap: n.spacingCarouselTextVerticalGap,
    overlayBackgroundColor: n.colourCarouselOverlay,
    borderRadius: n.borderRadiusCarouselFixed,
    wrapperTopSpacing: n.spacingCarouselPaddingTop,
    wrapperHorizontalSpacing: n.spacingCarouselPaddingHorizontal
  },
  drawer: {
    backgroundColor: n.colourDrawerBackgroundStandard,
    backgroundOverlay: n.colourDrawerBackgroundOverlay,
    handleColor: n.colourDrawerHandle,
    topGapHandle: n.spacingDrawerHandlePaddingTop,
    contentSpacingHorizontal: n.spacingDrawerPaddingHorizontal,
    borderRadiusTopLeft: n.borderRadiusDrawerTopLeft,
    borderRadiusTopRight: n.borderRadiusDrawerTopRight,
    hazaBackgroundColor: w,
    widthHandle: n.sizingDrawerHandle,
    headerBottomSpacing: n.spacingDrawerVerticalGap,
    // with search
    backgroundSelected: n.colourDrawerBackgroundSelected,
    textHeaderColor: n.colourDrawerTextHeader,
    textHintColor: n.colourDrawerTextHint,
    titlePinnedColor: n.colourDrawerTextTitlePinned,
    textTitleColor: n.colourDrawerTextTitle,
    textSubtitleColor: n.colourDrawerTextSubtitle,
    textStrikethrough: n.colourDrawerTextStrikethrough,
    listOptionsPaddingVetical: n.spacingInputListOptionsPaddingVertical,
    listOptionsPaddingHorizontal: n.spacingInputListOptionsPaddingHorizontal,
    listOptionPaddingVertial: n.spacingDrawerListOptionPaddingVertical,
    listOptionPaddingHorizontal: n.spacingDrawerListOptionPaddingHorizontal,
    listOptionHorizontalGap: n.spacingDrawerListOptionHorizontalGap,
    flagPaddingRight: n.spacingDrawerImageFlagPaddingRight,
    thumbnailPaddingRight: n.spacingDrawerImageThumbnailPaddingRight,
    listVerticalGap: n.spacingDrawerListVerticalGap,
    flagSize: n.sizingDrawerImageFlag,
    thumbnailSize: n.sizingDrawerImageThumbnail,
    headerPaddingTop: n.spacingDrawerHeaderPaddingTop,
    iconColor: n.colourDrawerIcon
  },
  stickyFooter: {
    boxHorizontalGap: n.spacingStickyFooterPaddingHorizontal,
    boxVerticalGap: n.spacingStickyFooterPaddingVertical,
    backgroundColor: n.colourStickyFooterBackground,
    borderTopDividerColor: n.colourStickyFooterBorderTop,
    buttonAndLinkGap: n.spacingStickyFooterTextLinkVerticalGap,
    variantHorizontalGap: n.spacingStickyFooterHorizontalGap,
    strikethroughTextColor: n.colourStickyFooterPriceStrikethrough
  },
  divider: {
    barColor: n.colourDivider10Horizontal,
    width: n.borderWidthDividerStandard,
    sectionTitleColor: n.colourDivider10Text,
    titleHorizontalGap: n.spacingDividerHorizontalGap
  },
  accordion: {
    titleColor: n.colourAccordionTextTitle,
    bodyColor: n.colourAccordionTextBody,
    iconColor: n.colourAccordionIcon,
    horizontalGap: n.spacingAccordionHorizontalGap,
    titlePaddingVertical: n.spacingAccordionTitlePaddingVertical,
    bodyPaddingBottom: n.spacingAccordionBodyPaddingBottom,
    iconSize: n.sizingAccordionIcon
  },
  bulletList: {
    textColor: n.colourBulletListText,
    iconColor: n.colourBulletListIcon,
    textHorizontalGap: n.spacingBulletListHorizontalGap,
    iconLeftSpacing: n.spacingBulletListPaddingLeft,
    textHorizontalGapSm: n.spacingBulletListHorizontalGapSm,
    iconSize: n.sizingBulletListIcon,
    iconSizeSm: n.sizingBulletListIconSm,
    bulletPointTopMarginBody: 12,
    bulletPointTopMarginSmallBody: 10
  },
  notification: {
    textTitle: n.colourNotificationTextTitle,
    textBody: n.colourNotificationTextBody,
    backgroundAlert: n.colourNotificationBackgroundAlert,
    backgroundInfo: n.colourNotificationBackgroundInfo,
    backgroundPromo: n.colourNotificationBackgroundPromo,
    boxHorizontalPadding: n.spacingNotificationPaddingHorizontal,
    boxHorizontalPaddingLg: n.spacingNotificationPaddingHorizontalLg,
    boxVerticalPadding: n.spacingNotificationPaddingVertical,
    buttonAndTextVerticalGap: n.spacingNotificationVerticalGap,
    iconColor: n.colourNotificationIcon,
    iconAndContentHorizontalGap: n.spacingNotificationHorizontalGap,
    linkAndContentVerticalGap: n.spacingNotificationTextLinkPaddingTop,
    iconSize: n.sizingNotificationIcon,
    borderRadius: n.borderRadiusNotification
  },
  circlePattern: {
    paddingTop: n.spacingCirclePatternVariant1TextPaddingTop,
    imageSizeVariant1: n.sizingCirclePatternVariant1,
    imageSizeVariant2: n.sizingCirclePatternVariant2,
    thumbnailVariant2PaddingLeft: n.spacingCirclePatternVariant2TextPaddingLeft
  },
  selector: {
    borderColorActive: n.colourSelectorBorderActive,
    borderWidthActive: n.borderWidthSelectorActive,
    borderColorStandard: n.colourSelectorBorderStandard,
    borderWidthStandard: n.borderWidthSelectorStandard,
    borderWidth: n.borderWidthSelectorActive,
    paddingTop: n.spacingSelectorPaddingVertical,
    paddingRight: n.spacingSelectorPaddingHorizontal,
    paddingBottom: n.spacingSelectorPaddingVertical,
    paddingLeft: n.spacingSelectorPaddingHorizontal,
    disabledMsgColor: n.colourSelectorTextUnavailable,
    subtitleTextColor: n.colourSelectorTextSubtitle,
    disabledTitleTextColor: n.colourSelectorTextDisabled,
    subTitlePaddingTop: n.spacingSelectorTextSubtitlePaddingTop
  },
  toast: {
    iconSuccessColor: n.colourToastIconSuccess,
    iconPendingColor: n.colourToastIconPending,
    iconAlertColor: n.colourToastIconAlert,
    itemSpacing: n.spacingToastHorizontalGap,
    backgroundColor: n.colourToastBackground,
    textColor: n.colourToastTextLinkInverse,
    borderRadius: n.borderRadiusToast,
    padding: n.spacingToastPaddingHorizontal
  },
  stepper: {
    outerSize: n.sizingStepperOuter,
    outerBorderColor: n.colourStepperBorderActive,
    colorTextActive: n.colourStepperTextActive,
    colorTextInactive: n.colourStepperTextInactive,
    backgroundColorActive: n.colourStepperBackgroundActive,
    backgroundColorInActive: n.colourStepperBackgroundInactive,
    colorIconSuccess: n.colourStepperBackgroundSuccess,
    innerSize: n.sizingStepperInner,
    backgroundColorSuccess: n.colourStepperIconSuccess,
    colorConnectorSuccess: n.colourStepperConnectorSuccess,
    colorConnectorInactive: n.colourStepperConnectorInactive
  },
  topNavigation: {
    backButtonColor: n.colourTopNavigationIconStandard,
    titleColor: n.colourTopNavigationTextStandard,
    colorBorderBottom: n.colourTopNavigationBorderBottom,
    backgroundColor: n.colourTopNavigationBackground,
    backgroundColorHaze: n.colourTopNavigationBackgroundHaze,
    paddingHorizontal: n.spacingTopNavigationHorizontalGap,
    iconButtonSize: n.sizingTopNavigationIcon,
    backgroundColorGradient: n.colourTopNavigationGradient,
    titleColorInverse: n.colourTopNavigationTextInverse,
    iconColorInverse: n.colourInputIconInverse
  },
  heroBanner: {
    titleColor: n.colourHeroBannerTextTitle,
    titleColorInverse: n.colourHeroBannerTextTitleInverse,
    subtitleColor: n.colourHeroBannerTextSubtitle,
    subtitleColorInverse: n.colourHeroBannerTextSubtitleInverse,
    indicatorColorInactive: n.colourHeroBannerIndicatorInactive,
    indicatorColorActive: n.colourHeroBannerIndicatorActive,
    indicatorPaddingBottom: n.spacingHeroBannerIndicatorPaddingBottom,
    indicatorHorizontalGap: n.spacingHeroBannerIndicatorHorizontalGap,
    textPaddingHorizontal: n.spacingHeroBannerTextPaddingHorizontal
  },
  tabs: {
    titleColor: n.colourTabsTextTitle,
    titleColorInactive: n.colourTabsTextTitleInactive,
    subtitleColor: n.colourTabsTextSubtitle,
    subtitleColorInactive: n.colourTabsTextSubtitleInactive,
    borderColorInactive: n.colourTabsBorderInactive,
    borderColorActive: n.colourTabsBorderActive,
    borderWidth: n.borderWidthTabsStandard,
    borderWidthActive: n.borderWidthTabsActive,
    tabVerticalGap: n.spacingTabsVerticalGap,
    tabPaddingHorizontal: n.spacingTabsPaddingHorizontal,
    //icons
    tabIconActive: n.colourTabsIconActive,
    tabIconInactive: n.colourTabsIconInactive,
    tabIconSize: n.sizingTabsIcon,
    tabsIconVerticalGap: n.spacingTabsIconVerticalGap
  },
  swimlane: {
    horizontalSpacing: n.spacingSwimlaneHorizontalGapMd
  },
  voucher: {
    colourVoucherBackground: n.colourVoucherBackground,
    colourVoucherTextTitle: n.colourVoucherTextTitle,
    colourVoucherTextSubtitle: n.colourVoucherTextSubtitle,
    colourVoucherTextSubtitleExpiring: n.colourVoucherTextSubtitleExpiring,
    colourVoucherTextPoints: n.colourVoucherTextPoints,
    colourVoucherIcon: n.colourVoucherIcon,
    borderRadiusVoucher: n.borderRadiusVoucher,
    spacingVoucherListViewTextPaddingHorizontal: n.spacingVoucherListViewTextPaddingHorizontal,
    spacingVoucherListViewTextVerticalGap: n.spacingVoucherListViewTextVerticalGap,
    spacingVoucherListViewTextPointsPaddingLeft: n.spacingVoucherListViewTextPointsPaddingLeft,
    sizingVoucherImage: n.sizingVoucherImage,
    sizingVoucherIcon: n.sizingVoucherIcon,
    shadowVoucherLow: n.shadowVoucherLow,
    colourVoucherBackgroundRedeemed: n.colourVoucherBackgroundRedeemed,
    colourVoucherTextTitleRedeemed: n.colourVoucherTextTitleRedeemed,
    colourVoucherTextSubtitleRedeemed: n.colourVoucherTextSubtitleRedeemed,
    colourVoucherTextPointsRedeemed: n.colourVoucherTextPointsRedeemed
  }
}), mT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  dlsStandard2: bT,
  ember: ST
}, Symbol.toStringTag, { value: "Module" }));
export {
  mT as app,
  BT as web
};
